/* eslint-disable no-console */
import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
  OnDestroy,
  ViewChild,
  ElementRef
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as Highcharts from 'highcharts';
import Highcharts3D from 'highcharts/highcharts-3d';
Highcharts3D(Highcharts);
import { CollectorApiService, ControllerApiService } from '@nrwl/test-setup';
import {
  HelpersService,
  LmapService,
  TestMode,
  WindowWalkService,
  LicensesPageService,
  DevicesService
} from '@nrwl/common-lib';
import { round, isEmpty } from 'lodash';
import {
  ReportsTransformationService,
  TableData
} from '../../../final.test.report/services/reports.transformation.service';
import { Y1564_RUNNING_CHART_CONFIG } from '../../../../../../test-running/src/lib/test-running/results/y1564/y1564-running-results/y1564-running-chart-config';

@Component({
  selector: 'nrwl-y1564-reports',
  templateUrl: './y1564.reports.component.html',
  styleUrls: ['./y1564.reports.component.scss']
})
export class Y1564ReportsComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('pdfPage') element: ElementRef;
  @Input() expertView: boolean;
  @Input() classicReport: boolean;
  @Input() reportName: string;
  @Input() chartId: string;
  @Input() reportStartTime: string;
  @Input() scheduleId: number;
  @Input() runId: number;
  @Input() testName: string;
  @Input() testData: string;
  @Input() onDemandTest: boolean;
  private readonly unsubscribe: Subject<void> = new Subject();
  overallConfiguration: any;
  shaId: string;
  isAgentToJmep = false;
  configuration = {};
  serverConfig = [];
  chartSeriesConfig = Y1564_RUNNING_CHART_CONFIG.series;
  selectedOriginator: any;
  activeLicense: string;
  licenseDetails: any = [];
  runSaturationWindow = false;
  dynamicSaturationWindow = false;
  testConfigsDataSource;
  dataSource: BehaviorSubject<any>;
  testType: string;
  requestInfo = {};
  streamNum = 0;

  loading: boolean;
  pageHeight: string;
  clientHeight: number;
  resultType: string;
  upstreamOn: boolean;
  downstreamOn: boolean;
  hasClientInfo: boolean;
  sptConfiguration = {};
  upstreamSummary = {};
  downstreamSummary = {};
  testSummary = {};
  isJmep = false;
  isQT = false;
  clientInfo = {};
  rtRequestCtr: number;
  rtTotalTime: number;
  windowResults = [];
  windowSummary = [];
  dataSourceItem = [];
  irCategories: string[] = [];
  irSeriesData = [];
  irChartId = 'ir-chart';
  flCategories: string[] = [];
  flSeriesData = [];
  flChartId = 'fl-chart';
  fdCategories: string[] = [];
  fdSeriesData = [];
  fdChartId = 'fd-chart';
  fdDistributionCategories = ['< 2ms', '< 4ms', '< 8ms', '< 16ms', '< 32ms', '< 64ms', '>= 64ms'];
  fdDistributionSeriesData = [];
  fdDistributionChartId = 'fd-distribution-chart';
  fdvCategories: string[] = [];
  fdvSeriesData = [];
  fdvChartId = 'fdv-chart';

  layer = '';
  trendingInProgress = false;
  trendingComplete = false;
  trendingMsg = '';
  trendingResults = [];
  trendingPercent = 0;
  chartArray = [];
  // chartArray: Highcharts.Chart[] = [];
  chartIdArray = [];
  rptSamplesNeeded = 0;
  rptSamplesReceived = 0;
  rptRequestCtr = 0;
  rptBatchSize = 1000;
  rptStartRequestTime = new Date();
  rptLastSampleDate = null;
  rptTotalTime = 0;
  rptSampleEndTime: any;
  rptRequestRetries = 0;
  rptMaxRequestRetries = 3;
  rptSeqNumsProcessed = [];
  rptTimeOutMs = 20;
  agedout = false;
  log = false;
  testMode = 'loopback';
  fdResultsAvailable = false;
  fdvResultsAvailable = false;

  startDate = null;
  stopDate = null;
  testConfig = null;
  streams = [];
  olderConfigVersion = false;
  testConfigDisplay: any = {
    overall: [],
    streams: [],
    destination: [],
    tpaVersion: null,
    tpbVersion: null
  };
  scEnabled = false;
  spEnabled = false;
  unknownText = 'Unknown';
  scResultsAvailable = false;
  spResultsAvailable = false;
  failText = 'Fail';
  overallResult = null;
  resultsNotAvailable = true;
  displayOverallResult = false;
  successText = 'Pass';
  inconclusiveText = 'Inconclusive';
  payloadTypeArray = {
    'fill-byte': 'Fill byte',
    prbs: 'PRBS'
  };
  layerToTest = '2';
  uiStreams = [];
  colors = {
    CHART_TWO_WAY_COLOR: '#28cbe0',
    CHART_NF_COLOR: '#ffba24',
    CHART_FN_COLOR: '#7b69ff',
    CHART_SLA_COLOR: '#3dd63d'
  };

  labels = {
    CHART_TWO_WAY_LABEL: 'Roundtrip Current FLR',
    CHART_NF_LABEL: 'A to B Current FLR',
    CHART_FN_LABEL: 'B to A Current FLR',
    CHART_SLA_LABEL: 'FLR Threshold',
    CHART_FD_SLA_LABEL: 'FD Threshold',
    CHART_FDV_SLA_LABEL: 'FDV Threshold',
    CHART_FD_LABEL: 'Roundtrip Current FD',
    CHART_FDV_LABEL: 'Roundtrip Current FDV'
  };

  testModeArray = {
    loopback: 'Loopback',
    unidirectional: 'Test Point A to Test Point B',
    'sequential-bidirectional': 'Sequential Bidirectional',
    'concurrent-bidirectional': 'Concurrent Bidirectional'
  };

  rtResultsRequested: number; // get all at once...max expected is < 8,000
  currentUrl: string;
  // logoUrl: string;
  message: string;
  isThinClientTest: boolean;
  thinClientTestinfo = [];
  // reportTitle: string;
  deviceType: string;
  public: boolean;
  testCapabilities: string;
  testpoints = [];
  upstreamDiagnosisMap = {};
  downstreamDiagnosisMap = {};
  diagnosisMessage = {};
  tagging = 'UNTAGGED';
  l1Rate;
  l3Rate;
  l2Rate;
  finishStatus: string;
  startRTRequestTime: Date;
  upstreamWindowResult;
  downstreamWindowResult;
  clientCpuUsage = [];
  clientMemoryUsage = [];
  displayedColumns: string[] = ['header', 'value'];
  testResultsDataSource;
  clientInfoDataSource;
  bulletChartOptions = {};
  truespeedTestResults: Array<TableData>;
  controllerStatus = '';
  streamRateConvention = 'L1 Mbps (ULR)';
  streamRateValue = 'l2-mbps';
  throughputInnerTableHeader = `<tr>
  <td class="throughput-inner-table-data">L1</td>
  <td class="throughput-inner-table-data">L2</td>
  <td class="throughput-inner-table-data">L3</td>
  <td class="throughput-inner-table-data">L4</td></tr>`;

  logoUrl = 'images/viavi-logo-purple.png';
  reportTitle = 'Y.1564 Test Report';
  scFinalReport: any;
  spFinalReport: any;
  spAngReport: any;
  scAngReport = [];
  showRtdOptions = false;
  formattedDate: any;
  duration: string;
  groupedReportForSc = [];
  uniqueScArray = [];
  uniqueSpArray = [];
  cirObjects: any[];
  eirScObject: any;
  eirSpObject: any;
  groupedReportForSp = [];
  policingScObject: any;
  trendChartsData = false;
  sctStepTime: string;
  ipAddressType = 'IPV4';
  sptOverallResult = [
    {
      title: 'Streams',
      value: '2'
    },
    {
      title: 'Total IR',
      value: '6',
      units: 'Mbps'
    },
    {
      title: 'Total TX Count',
      value: '228987'
    },
    {
      title: 'Total RX Count',
      value: '2567866'
    },
    {
      title: 'Total FL Count',
      value: '200000'
    },
    {
      title: 'Time Remaining',
      value: '00:00:56'
    }
  ];

  sptStreamsMetricData = [];
  SLA = {
    'ir-current': null,
    'frame-loss-ratio': null,
    'fd-current': null,
    'fdv-current': null
  };
  rtResults = [];
  metricsPresentData = {
    currentValu: null,
    unit: null,
    status: null
  };
  perTestDuration: any;
  performanceData: Array<{
    name: '';
    engineAData: {
      dataSourceItems: Array<any>;
      dataSource: BehaviorSubject<any>;
    };
    engineBData: {
      dataSourceItems: Array<any>;
      dataSource: BehaviorSubject<any>;
    };
    rxCount: any;
    frameLossCount: any;
    streamConfig: any;
    frameSize: any;
    vlanPriority: any;
    dscp: any;
  }>;
  y1564TestConfig: any;
  unitConvention: any;
  updatedTimeStamp: number;
  currentStream: any;
  tpBFlow = false;
  trendingInfoAvailable = false;
  tpAFlow: boolean;
  testStatus: any;
  testComplete: boolean;
  statusLabel: string;
  sctTestActive: boolean;
  sptTestActive: boolean;
  errorMsg: any;
  stepPercents: any;
  durationForStream: number;
  uiConfig: any;
  graphicMode: string;
  resultFormat_v2 = true;
  sortScAngReport: any[];
  engineACharts: {
    irCategories: any[];
    irSeriesData: { name: string; data: any[] }[];
    flCategories: any;
    flSeriesData: { name: string; data: any }[];
    fdCategories: any;
    fdSeriesData: { name: string; data: any }[];
    fdDistributionSeriesData: any;
    fdvCategories: any;
    fdvSeriesData: { name: string; data: any }[];
  };
  engineBCharts: {
    irCategories: any[];
    irSeriesData: { name: string; data: any[] }[];
    flCategories: any;
    flSeriesData: { name: string; data: any }[];
    fdCategories: any;
    fdSeriesData: { name: string; data: any }[];
    fdDistributionSeriesData: any;
    fdvCategories: any;
    fdvSeriesData: { name: string; data: any }[];
  };
  singleEngineCharts: {
    irCategories: any[];
    irSeriesData: { name: string; data: any[] }[];
    flCategories: any;
    flSeriesData: { name: string; data: any }[];
    fdCategories: any;
    fdSeriesData: { name: string; data: any }[];
    fdDistributionSeriesData: any;
    fdvCategories: any;
    fdvSeriesData: { name: string; data: any }[];
  };
  qtVersion = 'v2';
  verdictReason: any[];
  myError: any;
  errorMessage: string;
  verdictReasonAvailable = false;
  sortSpAngReport: any[];
  networkMacAddress: number;
  equipmentMacAddress: number;
  macAddress: number;
  testListData: any;
  versionValue: any;
  reportmessage: any;
  showCharts = false;
  originMngmtIpAddress: string;
  destinationMngmtIpAddress: string;
  primaryDeviceModel: string;
  constructor(
    private collectorApiService: CollectorApiService,
    private controllerApiService: ControllerApiService,
    private readonly helperService: HelpersService,
    private windowWalkService: WindowWalkService,
    private licenseService: LicensesPageService,
    readonly deviceService: DevicesService,
    private lmapService: LmapService,
    private transformService: ReportsTransformationService
  ) {
    this.loading = false;
    this.dataSource = new BehaviorSubject<any>({ noValue: true });
    this.rtRequestCtr = 0;
    this.rtTotalTime = 0;
    this.rtResultsRequested = 10000; // get all at once...max expected is < 8,000
    this.currentUrl = window.location.href;
  }

  ngOnInit(): void {
    this.init();
    this.performanceData = [];
  }

  init(): void {
    this.loading = true;
    this.deviceType = this.windowWalkService.getDeviceType();
    this.getServerConfig();
    this.getTestConfig();
    this.getLicenseDetails();
    this.trendingInProgress = false;
    this.trendingComplete = false;
  }

  getTestConfig(): void {
    this.controllerApiService
      .getTestConfig(this.scheduleId)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        if (response.status === 'success') {
          this.overallConfiguration = response.data.config;
          const deviceId = this.overallConfiguration?.agent?.primary?.id;
          const device = this.deviceService.findDeviceByUniqueName(deviceId);
          this.primaryDeviceModel = device?.['deviceData']?.['model']?.model;
          // this.getConfigurationData();
          this.shaId = response.data?.sha ? response.data.sha : null;
          const config = this.lmapService.getTestOptions(
            'y1564',
            ['y1564'],
            this.overallConfiguration
          );
          if (config && config.y1564) {
            this.y1564TestConfig = JSON.parse(config.y1564);
            this.testMode =
              this.y1564TestConfig['viavi-solutions-y1564:y1564']?.['y1564-parameters']?.mode;
          }
          this.isAgentToJmep = this.testMode?.toLowerCase() === TestMode.MA_TO_JMEP ? true : false;
          this.processReport();
          this.getRTResults();
        }
      });
  }

  getConfigurationData(): void {
    this.uiStreams = [];
    this.sptStreamsMetricData = [];
    if (this.overallConfiguration) {
      this.testConfigDisplayData();
      // this.registerForResults();
      const config = this.lmapService.getTestOptions('y1564', ['y1564'], this.overallConfiguration);
      if (config && config.y1564) {
        this.y1564TestConfig = JSON.parse(config.y1564);
        if (this.y1564TestConfig && this.y1564TestConfig['viavi-solutions-y1564:y1564']) {
          const unitConventionValue =
            this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
              'unit-convention'
            ];
          this.isJmep = this.y1564TestConfig['viavi-solutions-y1564:y1564']?.['engine-a-info']?.[
            'engine-type'
          ]
            ?.toLowerCase()
            ?.includes('jmep')
            ? true
            : false;
          this.isQT = this.y1564TestConfig['viavi-solutions-y1564:y1564']?.['engine-a-info']?.[
              'engine-type'
            ]
              ?.toLowerCase()
              ?.includes('qt')
              ? true
              : false;
          this.unitConvention = this.formatUnitConvention(unitConventionValue);
          // setup test mode for graphics
          switch (this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'].mode) {
            case 'concurrent-bidirectional':
            case 'sequential-bidirectional':
              if (
                this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'].mode ===
                'concurrent-bidirectional'
              ) {
                this.testType = 'Concurrent Bidirectional';
              } else {
                this.testType = 'Sequential Bidirectional';
              }
              break;

            case 'loopback':
              this.testType = 'Loopback';
              break;

            case 'unidirectional':
              this.testType = 'Test Point (A) to Test Point (B)';
              break;
            default:
              this.testType = 'Loopback';
              break;
          }

          this.layer =
            this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'].layer;
          this.stepPercents =
            this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
              'step-percents'
            ];
          this.ipAddressType =
            this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
              'ip-address-type'
            ] === 'ipv6'
              ? 'IPV6'
              : 'IPV4';
          // Join the array elements with dashes
          const formattedString = this.stepPercents?.length ? this.stepPercents.join('-') : '';
          this.stepPercents = formattedString;

          // ready the test data
          this.streams = this.y1564TestConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'];
          this.sctStepTime =
            this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
              'step-duration'
            ];
          this.perTestDuration =
            this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
              'perf-test-duration'
            ];

          this.durationForStream = this.perTestDuration * 60;
          // Modal default for step duration
          if (!this.sctStepTime) {
            this.sctStepTime = '10';
          }
        } else if (this.y1564TestConfig && this.y1564TestConfig['y1564:y1564']) {
          // setup test mode for graphics
          switch (this.y1564TestConfig['y1564:y1564']['y1564-parameters'].mode) {
            case 'concurrent-bidirectional':
            case 'sequential-bidirectional':
              if (
                this.y1564TestConfig['y1564:y1564']['y1564-parameters'].mode ===
                'concurrent-bidirectional'
              ) {
                this.testType = 'Concurrent Bidirectional';
              } else {
                this.testType = 'Sequential Bidirectional';
              }
              break;

            case 'loopback':
              this.testType = 'Loopback';
              break;

            case 'unidirectional':
              this.testType = 'Test Point (A) to Test Point (B)';
              break;
            default:
              this.testType = 'Loopback';
              break;
          }

          // ready the test data
          this.streams = this.y1564TestConfig['y1564:y1564']['group'][0]['streams'];
          this.sctStepTime =
            this.y1564TestConfig['y1564:y1564']['y1564-parameters']['step-duration'];
          this.perTestDuration =
            this.y1564TestConfig['y1564:y1564']['y1564-parameters']['perf-test-duration'];
          // Modal default for step duration
          if (!this.sctStepTime) {
            this.sctStepTime = '10';
          }
        }
      }

      // change up stream info. change and add what we need
      for (let x = 0, xlen = this.streams.length; x < xlen; ++x) {
        const mystream = this.streams[x];

        mystream.showStreamConfig = false;
        mystream.showSCTStreamConfig = false;
        mystream.name =
          mystream.name.indexOf(':') >= 0 ? mystream.name.split(':')[1] : mystream.name;
        mystream['sctStatusCIR'] = 'queue mdi-dots-horizontal';

        if (mystream['eir-from-engine-a'] > 0 || mystream['eir-from-engine-b'] > 0) {
          mystream['sctStatusEIR'] = 'queue mdi-dots-horizontal';
        } else {
          mystream['sctStatusEIR'] = 'no mdi-minus';
        }

        if (mystream['run-policing-from-engine-a'] || mystream['run-policing-from-engine-b']) {
          mystream['sctStatusPOLICING'] = 'queue mdi-dots-horizontal';
        } else {
          mystream['sctStatusPOLICING'] = 'no mdi-minus';
        }
        mystream.showFLRTrending = false;

        // change up tos/Diffserv values
        if (mystream['l3-ipv4-config']) {
          mystream['tosDiffLabel'] = 'ToS';
          mystream['tosDiffValue'] = this.helperService.formatTOS(mystream['l3-ipv4-config'].tos);
          if (this.uiStreams[x] && this.uiStreams[x].strmIpv4ToSDiffServ === 'diffserv') {
            mystream['tosDiffLabel'] = 'DiffServ';
            mystream['tosDiffValue'] = this.helperService.formatDiffValue(
              mystream['l3-ipv4-config'].tos
            );
          }
        }
        // configuration for metrics data
        this.sptConfiguration['streamName'] = mystream['name'];
        this.sptConfiguration['frameSize'] = mystream['l2-config']['spt-frame-size-list'];
        this.sptConfiguration['frameScSize'] = mystream['l2-config']['sct-frame-size-list'];
        this.sptConfiguration['vlanPriority'] = mystream['l2-config']['vlan-priority'];
        if (mystream['l3-ipv4-config']) {
          this.sptConfiguration['dscp'] = this.helperService.formatDiffValue(
            mystream['l3-ipv4-config'].tos
          );
        }

        this.sptStreamsMetricData.push(this.sptConfiguration);
      }
      this.initializePeformanceData();
    }
  }
  getServerConfig(): void {
    this.controllerApiService.getServerConfig().subscribe(response => {
      this.serverConfig = response.data;
      const serverConfig = response.data['reports'];
      if (serverConfig && serverConfig.logo && serverConfig.logo.url) {
        this.logoUrl = serverConfig.logo.url;
      }
      if (serverConfig && serverConfig.message) {
        this.reportmessage = serverConfig.message;
      }
    });
  }
  getLicenseDetails(): void {
    this.licenseService.getLicenseCount().subscribe(response => {
      this.licenseDetails = response;
    });
  }
  getRTResults(): void {
    this.rtRequestCtr++;
    this.startRTRequestTime = new Date();
    this.collectorApiService
      .getQueryReportByFromTime(this.scheduleId, this.runId, 'rt', this.reportStartTime, 1000)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(res => {
        if (res.status === 'success') {
          const getRTResultResponse = res.data;
          // this.processRTResults(getRTResultResponse);
          this.calculateTotalStat();
        }
      });
  }

  calculateTotalStat(): void {
    for (let windowCount = 0; windowCount < this.windowResults.length; windowCount++) {
      const windowResult = this.windowResults[windowCount];
      let totalTranmit = 0;
      let totalRetransmit = 0;
      for (let j = 0; j < windowResult.transmitted.length; j++) {
        totalTranmit += windowResult.transmitted[j];
        totalRetransmit += windowResult.retransmitted[j];
      }

      for (let k = 0; k < this.windowSummary.length; k++) {
        if (this.windowSummary[k]['window-id'] === windowResult.id) {
          this.windowSummary[k]['total-transmit'] = totalTranmit;
          this.windowSummary[k]['total-retransmit'] = totalRetransmit;
        }
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processRTResults(response) {
    // Check response to make sure it is valid
    const errorMsg = this.helperService.getResponseErrorMsg(response);
    if (errorMsg == null) {
      if (response) {
        let totalRtReports = 0;
        let lastSampleDate = '';
        if (response.length && response.length > 0) {
          totalRtReports = response.length;
          lastSampleDate = this.lmapService.getReportPostDate(response, response.length - 1);
        }

        // separate the report content into results per window
        const allRtReport = response;

        const currentTime = new Date();
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        const elapsedTime = currentTime - this.startRTRequestTime;
        this.rtTotalTime += elapsedTime;
        if (this.rtResultsRequested === totalRtReports) {
          setTimeout(function () {
            this.getRTResults(lastSampleDate);
          }, 500);
        } else {
          // order windowResults so that Window B's results follow Window A's for the same Window test
          let notDone = true;
          while (notDone === true) {
            notDone = false;
            for (let x = 0; x < this.windowResults.length && notDone === false; x = x + 2) {
              if (x + 1 < this.windowResults.length) {
                if (this.windowResults[x].status.indexOf('ENGINE_A') >= 0) {
                  const engineAStatus = this.windowResults[x].status;
                  const engineBStatus = engineAStatus.replace('ENGINE_A', 'ENGINE_B');
                  if (this.windowResults[x + 1].status !== engineBStatus) {
                    // find matching B data and move it after A
                    for (let z = 0; z < this.windowResults.length; z++) {
                      if (this.windowResults[z].status === engineBStatus) {
                        // first remove the item that is later in the array
                        const engineBData = this.windowResults.splice(z, 1);
                        if (engineBData[0]) {
                          // insert it righ after the associated A data
                          this.windowResults.splice(x + 1, 0, engineBData[0]);
                        }
                        //once we have changed the array, start checking from the beginning
                        notDone = true;
                        break;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    } else {
      this.windowResults = [];
    }
  }

  roundReportData(reportData: any[]): any[] {
    return reportData.map(item => {
      const newItem = { ...item };
      Object.keys(newItem).forEach(key => {
        if (newItem[key] && !isNaN(Number(newItem[key])) && key !== 'frame-loss-ratio') {
          newItem[key] = this.roundNumericValues([newItem[key]])[0]; // Apply rounding
        }
        if (key === 'step-name' && ['CIR', 'EIR', 'POLICING'].includes(newItem[key])) {
          newItem[key] = newItem[key].toLowerCase(); // Change to lowercase
        }
      });
      return newItem;
    });
  }

  roundNumericValues(values: any[]): any {
    return values.map(val => (!isNaN(Number(val)) ? round(parseFloat(val), 3).toString() : val));
  }

  // ToDo return type and parameter can be typed while integrated with backend.
  // eslint-disable-next-line
  processReport(): any {
    this.collectorApiService
      .getQueryReportByFromTime(this.scheduleId, this.runId, 'final', this.reportStartTime, 2)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        res => {
          if (res.status === 'success') {
            // Set start/stop dates
            this.startDate = null;
            this.stopDate = null;

            if (res && res.data && res.data.length) {
              for (let t = 0, tlen = res.data.length; t < tlen; ++t) {
                const tags = this.lmapService.getReportTag(res, t);
                this.versionValue = this.lmapService.getTagValue(tags, 'result-format');
                const report = res.data[t]['ietf-lmap-report:report'];
                this.formattedDate = this.helperService.getReportDateTimeString(
                  report.result[0].start
                );
                if (report) {
                  const myStopDate = new Date(report.date);
                  if (!this.stopDate || myStopDate.getTime() > this.stopDate.getTime()) {
                    this.stopDate = myStopDate;
                  }

                  if (!this.startDate && report.result && report.result.length > 0) {
                    this.startDate = new Date(report.result[0].start);
                  }
                }
              }
            }
            this.processStartStopDates();
            //overriding test config with current testid config
            const currentRunConfig = this.getTestConfigOption(res.data);
            if (!isEmpty(currentRunConfig)) {
              this.overallConfiguration.config[0].primaryConfig[
                'ietf-lmap-control:lmap'
              ].schedules.schedule[0].action[0].option = currentRunConfig;
            }
            this.getConfigurationData();
            this.requestInfo = this.createRequestInfo(this.overallConfiguration);

            let angularScFinalReport = null;
            let angularSpFinalReport = null;
            const reportIndex = null;
            if (res && typeof res.data === 'object') {
              let idx = res.data.length - 1;
              while ((angularScFinalReport == null || angularSpFinalReport == null) && idx >= 0) {
                if (angularScFinalReport == null) {
                  angularScFinalReport = this.lmapService.ltranslateLmapReportIndexToAngular(
                    res.data,
                    'sc',
                    idx
                  );
                }
                if (angularSpFinalReport == null) {
                  angularSpFinalReport = this.lmapService.ltranslateLmapReportIndexToAngular(
                    res.data,
                    'sp',
                    idx
                  );
                }
                idx--;
              }
            }

            // massage the SC results to group each step's outcome within the stream tested for better data display
            let scReport = null;
            if (angularScFinalReport) {
              scReport = {};
              this.convertAngularReportToDisplay(angularScFinalReport, scReport);
            }

            let spReport = null;
            if (angularSpFinalReport) {
              spReport = {};
              this.convertAngularReportToDisplay(angularSpFinalReport, spReport);
            }

            // assign new data to model variables for display
            this.scFinalReport = scReport;
            this.spFinalReport = spReport;
            this.spAngReport = angularSpFinalReport;
            this.scAngReport = angularScFinalReport;
            if (this.spAngReport) {
              this.spAngReport = this.roundReportData(this.spAngReport);
            }
            if (this.scAngReport) {
              this.scAngReport = this.roundReportData(this.scAngReport);
            }

            if (this.scAngReport) {
              this.sortScAngReport = this.scAngReport.sort((a, b) => {
                const numA = parseInt(a['stream-number'], 10); // Parse as integer
                const numB = parseInt(b['stream-number'], 10); // Parse as integer

                return numA - numB; // Compare numerically
              });
              const groupedReport = this.groupByStreamNumber(this.scAngReport);
              for (const streamNumber in groupedReport) {
                const group = groupedReport[streamNumber];
                this.getScFailedOrCirObject(group);
              }
            }
            if (this.spAngReport) {
              this.sortSpAngReport = this.spAngReport.sort((a, b) => {
                const numA = parseInt(a['stream-number'], 10); // Parse as integer
                const numB = parseInt(b['stream-number'], 10); // Parse as integer

                return numA - numB; // Compare numerically
              });
              const groupedSpReport = this.groupByStreamNumber(this.spAngReport);
              for (const streamNumber in groupedSpReport) {
                const group = groupedSpReport[streamNumber];
                this.getSpFailedOrCirObject(group);
              }
              const responseData = this.spAngReport;
              const engineAData = responseData.filter(item => item.originator === 'engine-a');
              const engineBData = responseData.filter(item => item.originator === 'engine-b');

              if (engineBData.length > 0) {
                this.processData(engineAData, 'engine-a');
                this.processData(engineBData, 'engine-b');
              } else {
                this.processData(responseData, 'all engines');
              }

              // this.processData(responseData);
            }
            // All Righty! If we have an MA config then let's build the configuration section of
            // the report

            //Y1564 report check
            if (this.overallConfiguration) {
              if (this.overallConfiguration?.agent) {
                const originAgentName = this.overallConfiguration.agent?.primary?.id || '';
                const destAgentName = this.overallConfiguration.agent?.secondary?.[0]?.id || '';

                const originatorDevice = this.deviceService.findDeviceByUniqueName(originAgentName);
                const destinationDevice = this.deviceService.findDeviceByUniqueName(destAgentName);

                this.originMngmtIpAddress = originatorDevice?.deviceData?.mgmtIPaddress || '';
                this.destinationMngmtIpAddress = destinationDevice?.deviceData?.mgmtIPaddress || '';
              }

              const config = this.lmapService.getTestOptions(
                'y1564',
                ['y1564'],
                this.overallConfiguration
              );
              if (config && config.y1564) {
                try {
                  this.testConfig = JSON.parse(config.y1564);
                } catch (err) {
                  console.log('JSON parse error for test config: ' + err.errorMessage);
                }

                if (this.testConfig && this.testConfig['y1564:y1564']) {
                  if (
                    this.testConfig['y1564:y1564']['group'] &&
                    this.testConfig['y1564:y1564']['group'].length &&
                    this.testConfig['y1564:y1564']['group'][0]['streams'] &&
                    this.testConfig['y1564:y1564']['group'][0]['streams'].length
                  ) {
                    this.streams = this.testConfig['y1564:y1564']['group'][0]['streams'];
                    this.olderConfigVersion = false;
                  } else if (
                    this.testConfig['y1564:y1564']['streams'] &&
                    this.testConfig['y1564:y1564']['streams'].length
                  ) {
                    this.streams = this.testConfig['y1564:y1564']['streams'];
                    this.olderConfigVersion = true;
                  }
                } else if (this.testConfig && this.testConfig['viavi-solutions-y1564:y1564']) {
                  if (
                    this.testConfig['viavi-solutions-y1564:y1564']['group'] &&
                    this.testConfig['viavi-solutions-y1564:y1564']['group'].length &&
                    this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'] &&
                    this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'].length
                  ) {
                    this.streams =
                      this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'];
                    this.olderConfigVersion = false;
                  } else if (
                    this.testConfig['viavi-solutions-y1564:y1564']['streams'] &&
                    this.testConfig['viavi-solutions-y1564:y1564']['streams'].length
                  ) {
                    this.streams = this.testConfig['viavi-solutions-y1564:y1564']['streams'];
                    this.olderConfigVersion = true;
                  }
                }
              }
            } else {
              console.log(
                'y1564 final report: Cannot create configuratuion section - controller configuration is not present'
              );
            }

            if (this.testConfig) {
              // MV-15833 - get JMEP type. Show FTD bins if JMEP-1G
              if (
                this.testConfig['y1564:y1564'] &&
                this.testConfig['y1564:y1564']['engine-a-info'] &&
                this.testConfig['y1564:y1564']['engine-a-info']['engine-type'] === 'JMEP-1G'
              ) {
                this.showRtdOptions = true;
              } else if (
                this.testConfig['viavi-solutions-y1564:y1564'] &&
                this.testConfig['viavi-solutions-y1564:y1564']['engine-a-info'] &&
                this.testConfig['viavi-solutions-y1564:y1564']['engine-a-info']['engine-type'] ===
                  'JMEP-1G'
              ) {
                this.showRtdOptions = true;
              } else {
                this.showRtdOptions = false;
              }

              if (res.data && res.data.length > 0 && res.data[0]['ietf-lmap-report:report']) {
                this.testConfig['agent-id'] = res.data[0]['ietf-lmap-report:report']['agent-id'];
                const originatorDevice = this.deviceService.getDeviceById(
                  this.testConfig['agent-id']
                );
                if (
                  this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
                    'tx-interface'
                  ] &&
                  originatorDevice &&
                  originatorDevice.deviceData &&
                  originatorDevice.deviceData.capabilities.phy
                ) {
                  this.networkMacAddress =
                    originatorDevice.deviceData.capabilities.phy['network-mac'];
                  this.equipmentMacAddress =
                    originatorDevice.deviceData.capabilities.phy['equipment-mac'];
                }
                const d = new Date(res.data[0]['ietf-lmap-report:report']['date']);
                this.testConfig['date'] = d.toDateString();
                this.testConfig['group-id'] = res.data[0]['ietf-lmap-report:report']['group-id'];
              }

              if (this.testConfigDisplay.overall.length == 0) {
                if (this.primaryDeviceModel == 'QT600-10') {
                  this.createOverallQTTestSetup();
                } else {
                  this.createOverallTestSetup(); //must be done before streams setup since vars are set
                }
              }

              if (this.testConfigDisplay.streams.length == 0) {
                if (this.primaryDeviceModel == 'QT600-10') {
                  this.createStreamsQTTestSetup();
                } else {
                  this.createStreamsTestSetup();
                }
              }
              const streams = this.streams;
              for (let a = 0, alen = streams.length; a < alen; ++a) {
                streams[a]['spResults'] = [];
                streams[a]['scResults'] = [];
              }

              if (this.spFinalReport != null) {
                // combine the spResults to the testconfig stream data for ease of parsing
                let isZeroBased = false;
                for (let b = 0, blen = this.spFinalReport.length; b < blen; ++b) {
                  if (this.spFinalReport[b]['stream-number'] === '0') {
                    isZeroBased = true;
                    break;
                  }
                }

                for (let c = 0, clen = this.spFinalReport.length; c < clen; ++c) {
                  const result = this.spFinalReport[c];
                  let snum = parseInt(result['stream-number'], 10);
                  if (!isZeroBased) snum -= 1;

                  if (streams[snum] && streams[snum].spResults) {
                    streams[snum].spResults.push(result);
                  }
                }
              }
            }

            // set model variables indicating if results were found
            let results = this.unknownText;

            if (this.scAngReport != null) {
              this.scResultsAvailable = true;

              // MV-16030 - need to be backwards compat with Fusion 9 results
              if (this.scAngReport.length && this.scAngReport[0]['Frame Size']) {
                this.transform9Results(this.scAngReport);
              }

              results = this.getVerdict(this.scAngReport);
            } else {
              this.scResultsAvailable = false;
            }

            if (this.spAngReport != null) {
              this.spResultsAvailable = true;

              // MV-16030 - need to be backwards compat with Fusion 9 results
              if (this.spAngReport.length && this.spAngReport[0]['Frame Size']) {
                this.transform9Results(this.spAngReport);
              }

              if (results !== this.failText) {
                results = this.getVerdict(this.spAngReport);
              }

              let timeRemaining = '';
              for (const x in this.spAngReport) {
                const report = this.spAngReport[x];
                timeRemaining = this.helperService.convertSecondsToHMS(report['time-remaining']);
                for (let si = 0; si < this.streams.length; ++si) {
                  if (this.streams[si].name === report['stream-name']) {
                    this.streamNum = si;
                    // this.updateSPDataSource(si, report, this.updatedTimeStamp);
                    // this.performanceData['txCount'] = report['tx-frame-count'];
                    this.performanceData[si]['rxCount'] = report['rx-frame-count'];
                    this.performanceData[si]['frameLossCount'] = report['frame-loss-count'];
                    this.performanceData[si]['streamConfig'] = this.streams[this.streamNum];
                    this.performanceData[si]['frameSize'] =
                      this.sptStreamsMetricData[si]['frameSize'];
                    this.performanceData[si]['vlanPriority'] =
                      this.sptStreamsMetricData[si]['vlanPriority'];
                    this.performanceData[si]['dscp'] = this.sptStreamsMetricData[si]['dscp'];
                    break;
                  }
                }
                this.currentStream = this.streams[this.streamNum];
                this.streams[this.streamNum]['stream-number'] = report['stream-number'];

                if (report['average-thruput']) {
                  const thruey = { tp: parseFloat(report['average-thruput']), units: 'mbps' };
                  this.adjustThruput(thruey);
                  report['average-thruput'] = thruey.tp;
                  report['average-thruput-units'] = thruey.units;
                }
                // add data and update animation
                if (report['originator'] === 'ENGINE_A') {
                  if (this.graphicMode === 'loop') {
                    if (this.streams[this.streamNum].rtData) {
                      this.streams[this.streamNum].rtData = null;
                    }
                    this.streams[this.streamNum].rtData = report;
                  } else {
                    this.tpAFlow = true;
                    this.streams[this.streamNum].rtData = report;
                  }
                }

                if (report['originator'] === 'ENGINE_B') {
                  this.tpBFlow = true;
                  this.streams[this.streamNum].rtDataB = report;
                }
              }
            } else {
              this.spResultsAvailable = false;
            }

            this.overallResult = results;

            if (this.scResultsAvailable == false && this.spResultsAvailable == false) {
              this.resultsNotAvailable = true;
            } else {
              this.resultsNotAvailable = false;
              this.displayOverallResult = true;
            }
            if (this.overallResult !== this.successText) {
              let testType = 'In Service Performance';
              if (this.showRtdOptions) {
                this.myError = this.getVerdictReason(res, 'sp');
              } else if (this.primaryDeviceModel == 'QT600-10') {
                this.myError = this.produceErrorQTObj(this.spAngReport);
              } else {
                this.myError = this.produceErrorObj(this.spAngReport);
              }
              if (!this.myError) {
                testType = 'In Service Configuration';
                if (this.showRtdOptions) {
                  this.myError = this.getVerdictReason(res, 'sc');
                } else if (this.primaryDeviceModel == 'QT600-10') {
                  this.myError = this.produceErrorQTObj(this.scAngReport);
                } else {
                  this.myError = this.produceErrorObj(this.scAngReport);
                }
              }
              if (this.myError) {
                this.errorMessage = testType + ', ' + this.myError;
              }
            }
          }

          this.loading = false;
        },
        () => {
          this.getConfigurationData();
          this.loading = false;
        }
      );
  }

  //eslint-disable-next-line
  getTestConfigOption(response): any {
    let optionValue = [];
    if (response.length) {
      const reports = response[0];
      let testOptions = [];
      reports['ietf-lmap-report:report'].result.forEach(item => {
        if (item?.option?.length && testOptions.length === 0) {
          testOptions = item.option;
        }
      });
      optionValue = testOptions;
    }
    return optionValue;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  convertAngularReportToDisplay(angularReport, displayReport) {
    if (angularReport != null) {
      for (let x = 0, len = angularReport.length; x < len; ++x) {
        const rpt = angularReport[x];

        if (rpt['originator'] && rpt['stream-number'] && rpt['frame-size-average']) {
          const strmIdx = rpt['stream-number'];

          // add the unique stream if not already there
          if (!displayReport[strmIdx]) {
            displayReport[strmIdx] = {
              'stream-number': rpt['stream-number'],
              'stream-name': rpt['stream-name'],
              directions: {}
            };
          }

          // add the direction (from a or from b) if not alreay there
          const origIdx = rpt['originator'];
          if (!displayReport[strmIdx].directions[origIdx]) {
            const directionObj = {
              originator: rpt['originator'],
              'frame-size-average': rpt['frame-size-average'],
              steps: []
            };
            displayReport[strmIdx].directions[origIdx] = directionObj;
          }

          // add the step results to the direction
          displayReport[strmIdx].directions[origIdx].steps.push(rpt);
        }
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createStreamsTestSetup() {
    if (this.streams.length) {
      const numStreams = this.streams.length;
      const streams = this.streams;
      let addedDestination = false;
      let addedDestinationIP = false;
      let addedVlan = false;
      let addedInnerVlan = false;
      let addedVlanTagCount = false;
      let isLayer3 = null;
      let layerConfig = null;
      if (this.testConfig['y1564:y1564']) {
        isLayer3 =
          this.testConfig['y1564:y1564']['y1564-parameters'] &&
          this.testConfig['y1564:y1564']['y1564-parameters']['layer'] &&
          this.testConfig['y1564:y1564']['y1564-parameters']['layer'] === 'L3';
      } else if (this.testConfig['viavi-solutions-y1564:y1564']) {
        isLayer3 =
          this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters'] &&
          this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters']['layer'] &&
          this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters']['layer'] === 'L3';
      }
      for (let y = 0; y < numStreams; ++y) {
        const newStream = {};
        // start with default values from model in case attributes are not included in configuration
        newStream['run-policing-from-engine-a'] = 'No';
        newStream['run-policing-from-engine-b'] = 'No';
        newStream['frame-loss-ratio-threshold'] = 0;
        newStream['enable-frame-delay'] = 'No';
        newStream['frame-length'] = 64;
        newStream['payload'] = this.payloadTypeArray['fill-byte'];
        newStream['tos'] = '00000000';
        newStream['ttl'] = 0;
        newStream['vlan-tagging'] = 'untagged';
        newStream['cvlan-id'] = '';
        newStream['cvlan-priority'] = '';
        newStream['svlan-id'] = '';
        newStream['svlan-priority'] = '';
        newStream['svlan-tpid'] = '';
        newStream['svlan-deiEnabled'] = '';

        if (this.resultFormat_v2) {
          newStream['tos'] = '0';
          newStream['ttl'] = 32;
        }

        for (const z in streams[y]) {
          switch (z) {
            case 'name':
              // remove connection name since only one connection is supported
              // eslint-disable-next-line no-case-declarations
              const idx = streams[y][z].indexOf(':');
              if (idx > 0 && streams[y][z].length > idx + 1) {
                newStream[z] = streams[y][z].substr(idx + 1);
              } else {
                newStream[z] = streams[y][z];
              }
              break;

            case 'run-policing-from-engine-a':
            case 'run-policing-from-engine-b':
            case 'enable-frame-delay':
              if (streams[y][z] === true) {
                newStream[z] = 'Yes';
              } else {
                newStream[z] = 'No';
              }
              break;

            case 'l2-config':
              // eslint-disable-next-line no-case-declarations
              layerConfig = Object.assign({}, streams[y][z]);
              //MAC address should only be shown on L3 report if it was entered by the user
              if (
                addedDestination === false &&
                isLayer3 &&
                layerConfig['arp-mode'] === 'false' &&
                layerConfig['destination-mac']
              ) {
                this.testConfigDisplay.destination.push({
                  name: 'MAC Address',
                  value: layerConfig['destination-mac']
                });
                addedDestination = true; // only add once, it is the same for all streams
              } else if (
                this.olderConfigVersion &&
                addedDestination === false &&
                layerConfig['destination-mac']
              ) {
                this.testConfigDisplay.destination.push({
                  name: 'MAC Address',
                  value: layerConfig['destination-mac']
                });
                addedDestination = true; // only add once, it is the same for all streams
              } else if (
                addedDestination === false &&
                isLayer3 === false &&
                layerConfig['destination-mac']
              ) {
                // MV-16121 - Ron wants to see it for layer 2 test
                this.testConfigDisplay.destination.push({
                  name: 'MAC Address',
                  value: layerConfig['destination-mac']
                });
                addedDestination = true;
              }

              if (layerConfig['vlan-id'] && addedVlan === false) {
                this.testConfigDisplay.destination.push({
                  name: 'S-VLAN',
                  value: layerConfig['vlan-id']
                });
                if (layerConfig['ether-type']) {
                  this.testConfigDisplay.destination.push({
                    name: 'S-Ether Type',
                    value: layerConfig['ether-type']
                  });
                }
                if (layerConfig['vlan-priority']) {
                  this.testConfigDisplay.destination.push({
                    name: 'S-VLAN Priority',
                    value: layerConfig['vlan-priority']
                  });
                }
                addedVlan = true;
              }
              if (layerConfig['inner-vlan-id'] && addedInnerVlan === false) {
                this.testConfigDisplay.destination.push({
                  name: 'C-VLAN',
                  value: layerConfig['inner-vlan-id']
                });
                if (layerConfig['inner-ether-type']) {
                  this.testConfigDisplay.destination.push({
                    name: 'C-Ether Type',
                    value: layerConfig['inner-ether-type']
                  });
                }
                if (layerConfig['inner-vlan-priority']) {
                  this.testConfigDisplay.destination.push({
                    name: 'C-VLAN Priority',
                    value: layerConfig['inner-vlan-priority']
                  });
                }
                addedInnerVlan = true;
              }
              if (layerConfig['remote-tag-count'] && addedVlanTagCount === false) {
                this.testConfigDisplay.destination.push({
                  name: 'Remote VLAN Tag Count',
                  value: layerConfig['remote-tag-count']
                });
                addedVlanTagCount = true;
              }
              if (layerConfig['sct-frame-size-list']) {
                newStream['sct-frame-length'] = layerConfig['sct-frame-size-list'];
              }
              if (layerConfig['spt-frame-size-list']) {
                newStream['spt-frame-length'] = layerConfig['spt-frame-size-list'];
              }
              if (layerConfig['frame-length']) {
                newStream['frame-length'] = layerConfig['frame-length'];
              }

              if (layerConfig['payload']) {
                if (this.payloadTypeArray[layerConfig['payload']]) {
                  newStream['payload'] = this.payloadTypeArray[layerConfig['payload']];
                } else {
                  newStream['payload'] = layerConfig['payload'];
                }
              }
              if (layerConfig['inner-vlan-id']) {
                newStream['vlan-tagging'] = 'QINQ';
                newStream['svlan-id'] = layerConfig['vlan-id'];
                newStream['svlan-priority'] = layerConfig['vlan-priority'];
                newStream['svlan-tpid'] = layerConfig['ether-type'];
                newStream['svlan-deiEnabled'] = layerConfig['dei-enabled'] ? 'true' : 'false';

                newStream['cvlan-id'] = layerConfig['inner-vlan-id'];
                newStream['cvlan-priority'] = layerConfig['inner-vlan-priority'];
              } else if (layerConfig['vlan-id']) {
                newStream['vlan-tagging'] = 'tagged';
                newStream['svlan-id'] = layerConfig['vlan-id'];
                newStream['svlan-priority'] = layerConfig['vlan-priority'];
              }

              break;

            case 'vlan':
            case 'cvlan':
              newStream['cvlan-id'] = layerConfig.id;
              newStream['cvlan-priority'] = layerConfig.priority;
              break;

            case 'svlan':
              newStream['svlan-id'] = layerConfig.id;
              newStream['svlan-priority'] = layerConfig.priority;
              newStream['svlan-tpid'] = layerConfig.tpid;
              newStream['svlan-deiEnabled'] = layerConfig['dei-enabled'] ? 'true' : 'false';
              break;
            case 'l3-ipv4-config':
              layerConfig = Object.assign({}, streams[y][z]);
              if (!addedDestinationIP) {
                if (streams[y]['l3-ipv4-config']['destination-ip']) {
                  this.testConfigDisplay.destination.push({
                    name: 'IP Address',
                    value: streams[y]['l3-ipv4-config']['destination-ip']
                  });
                  addedDestinationIP = true; // only add once, it is the same for all streams
                } else if (streams[y]['destination-ip']) {
                  this.testConfigDisplay.destination.push({
                    name: 'IP Address',
                    value: streams[y]['destination-ip']
                  });
                  addedDestinationIP = true; // only add once, it is the same for all streams
                }
              }
              if (layerConfig['vlan-id'] && addedVlan === false) {
                this.testConfigDisplay.destination.push({
                  name: 'S-VLAN',
                  value: layerConfig['vlan-id']
                });
                if (layerConfig['ether-type']) {
                  this.testConfigDisplay.destination.push({
                    name: 'S-Ether Type',
                    value: layerConfig['ether-type']
                  });
                }
                if (layerConfig['vlan-priority']) {
                  this.testConfigDisplay.destination.push({
                    name: 'S-VLAN Priority',
                    value: layerConfig['vlan-priority']
                  });
                }
                addedVlan = true;
              }
              if (layerConfig['inner-vlan-id'] && addedInnerVlan === false) {
                this.testConfigDisplay.destination.push({
                  name: 'C-VLAN',
                  value: layerConfig['inner-vlan-id']
                });
                if (layerConfig['inner-ether-type']) {
                  this.testConfigDisplay.destination.push({
                    name: 'C-Ether Type',
                    value: layerConfig['inner-ether-type']
                  });
                }
                if (layerConfig['inner-vlan-priority']) {
                  this.testConfigDisplay.destination.push({
                    name: 'C-VLAN Priority',
                    value: layerConfig['inner-vlan-priority']
                  });
                }
                addedInnerVlan = true;
              }
              if (layerConfig['remote-tag-count'] && addedVlanTagCount === false) {
                this.testConfigDisplay.destination.push({
                  name: 'Remote VLAN Tag Count',
                  value: layerConfig['remote-tag-count']
                });
                addedVlanTagCount = true;
              }
              if (layerConfig['tos'] !== undefined && layerConfig['tos'] !== null) {
                newStream['toSDiffServSelection'] = 'ToS';
                newStream['toSDiffServValue'] = this.helperService.formatDiffValue(
                  layerConfig['tos']
                );
              }
              if (layerConfig['ttl']) {
                newStream['ttl'] = layerConfig['ttl'];
              }
              if (layerConfig['frame-length']) {
                newStream['frame-length'] = layerConfig['frame-length'];
              }
              if (layerConfig['payload']) {
                if (this.payloadTypeArray[layerConfig['payload']]) {
                  newStream['payload'] = this.payloadTypeArray[layerConfig['payload']];
                } else {
                  newStream['payload'] = layerConfig['payload'];
                }
              }
              if (this.layerToTest == '3' && layerConfig['filter-on-tos'] !== undefined) {
                newStream['filter-on-tos'] = layerConfig['filter-on-tos'].toString();
              }
              break;
            default:
              newStream[z] = streams[y][z];
              break;
          }
        }

        // get UI stream configuration if present because it's more accurate for display
        //
        if (newStream['stream-number']) {
          const uiStreamData = this.getUIStream(newStream['stream-number']);

          if (uiStreamData) {
            if (newStream['cir-from-engine-a'] && uiStreamData.strmSlaCir) {
              newStream['cir-from-engine-a'] = uiStreamData.strmSlaCir;
            }
            if (newStream['eir-from-engine-a'] && uiStreamData.strmSlaEir) {
              newStream['eir-from-engine-a'] = uiStreamData.strmSlaEir;
            }
            if (newStream['max-ir-from-engine-a'] && uiStreamData.strmSlaMaxIR) {
              newStream['max-ir-from-engine-a'] = uiStreamData.strmSlaMaxIR;
            }

            if (newStream['cir-from-engine-b'] && uiStreamData.strmSlaCir2) {
              newStream['cir-from-engine-b'] = uiStreamData.strmSlaCir2;
            }
            if (newStream['eir-from-engine-b'] && uiStreamData.strmSlaEir2) {
              newStream['eir-from-engine-b'] = uiStreamData.strmSlaEir2;
            }
            if (newStream['max-ir-from-engine-b'] && uiStreamData.strmSlaMaxIR2) {
              newStream['max-ir-from-engine-b'] = uiStreamData.strmSlaMaxIR2;
            }

            // While we have the UI data, retrieve the DSCP value if user entered it that way
            if (this.layerToTest == '3' || this.layerToTest == '2') {
              if (
                uiStreamData.strmIpv4ToSDiffServ &&
                uiStreamData.strmIpv4ToSDiffServ === 'diffserv'
              ) {
                newStream['toSDiffServSelection'] = 'DiffServ';
                newStream['toSDiffServValue'] = this.helperService.formatDiffValue(
                  uiStreamData.strmIpv4DiffServVal
                );
              }
            }
          }
        }
        this.testConfigDisplay.streams.push(newStream);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processStartStopDates() {
    function padZero(x) {
      return x < 10 ? '0' + x : x.toString();
    }
    if (this.stopDate && this.startDate) {
      let diffTime = this.stopDate.getTime() - this.startDate.getTime();
      diffTime = diffTime / 1000;

      let minutes = Math.floor(diffTime / 60);
      const seconds = diffTime % 60;
      let hours = 0;
      if (minutes >= 60) {
        hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
      }
      let days = 0;
      if (hours >= 24) {
        days = Math.floor(hours / 24);
        hours = hours % 24;
      }

      this.duration =
        (days ? days + 'd ' : '') +
        (hours ? hours + 'h ' : '') +
        (minutes ? minutes + 'm ' : '') +
        seconds +
        's';
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  transform9Results(angReport) {
    const Fusion9KeyMap = {
      'Stream Name': 'name',
      streamName: 'streamName',
      'Duration (secs)': 'duration',
      'Frame Size': 'frame-size-average',
      'Test Phase': 'step-name',
      'Target IR (Mbps)': 'target-ir',
      'Transmitted IR (Mbps)': 'transmitted-ir',
      'Transmitted ULR (Mbps)': 'transmitted-ulr',
      'IR Min (Mbps)': 'ir-min',
      'IR Avg (Mbps)': 'ir-avg',
      'IR Max (Mbps)': 'ir-max',
      'Network ULR (Mbps)': 'network-ulr',
      'Total Frames Lost': 'frame-loss-count',
      'Frame Loss Ratio (%)': 'frame-loss-ratio',
      'Peak Frame Loss Ratio (%)': 'peak-frame-loss-ratio',
      'Frame Loss SLA (%)': 'frame-loss-sla',
      'FTD Min (ms)': 'rtd-min',
      'FTD Avg (ms)': 'rtd-avg',
      'FTD Max (ms)': 'rtd-max',
      'FTD SLA (ms)': 'rtd-sla',
      'Count of frames with FTD &lt; 2 ms': 'rtd-lt-2ms',
      '2 ms &lt;= FTD &lt; 4 ms': 'rtd-2ms-to-4ms',
      '4 ms &lt;= FTD &lt; 8 ms': 'rtd-4ms-to-8ms',
      '8 ms &lt;= FTD &lt; 16 ms': 'rtd-8ms-to-16ms',
      '16 ms &lt;= FTD &lt; 32 ms': 'rtd-16ms-to-32ms',
      '32 ms &lt;= FTD &lt; 64 ms': 'rtd-32ms-to-64ms',
      'Count of frames with FTD &gt;=64 ms': 'rtd-gt-64ms',
      'FDV Avg (ms)': 'fdv-avg',
      'FDV Max (ms)': 'fdv-max',
      'FDV SLA (ms)': 'fdv-sla',
      'OOS Max': 'oos-max',
      'OOS Min': 'oos-min',
      'OOS Avg': 'oos-avg',
      'OOS Total': 'oos-count',
      verdict: 'verdict',
      'verdict-reason': 'verdict-reason'
    };

    for (let i = 0; i < angReport.length; ++i) {
      for (const key in angReport[i]) {
        angReport[i][Fusion9KeyMap[key]] = angReport[i][key];
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getVerdict(angularReport) {
    let verdict = this.unknownText;

    for (const x in angularReport) {
      for (const y in angularReport[x]) {
        if (y === 'verdict-reason') {
          this.verdictReason = angularReport[x][y];
        }
        if (typeof y === 'string' && y === 'verdict') {
          switch (angularReport[x][y]) {
            case 'pass':
              verdict = this.successText;
              break;
            case 'fail':
              verdict = this.failText;
              break;
            case 'inconclusive':
              verdict = this.inconclusiveText;
              break;
          }
        }
      }

      if (verdict === this.failText || verdict === this.inconclusiveText) {
        break;
      }
    }

    return verdict;
  }

  getUIStream(streamNum: number): any {
    const mynum = parseInt(streamNum.toString()) - 1;
    if (this.uiStreams[mynum]) {
      return this.uiStreams[mynum];
    } else {
      return null;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getStreamName(streamNum) {
    const uiStream = this.getUIStream(streamNum);
    if (uiStream) {
      return uiStream.strmName || uiStream.name;
    } else {
      return 'Stream ' + streamNum;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getErrorStreamName(streamNum) {
    const uiStream = this.getUIStream(streamNum);
    if (uiStream) {
      return uiStream.name;
    } else {
      return 'Stream ' + streamNum;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  groupByStreamNumber(report) {
    const grouped = {};
    report.forEach(obj => {
      const streamNumber = obj['stream-number'];
      this.getStreamName(streamNumber);
      if (!grouped[streamNumber]) {
        grouped[streamNumber] = [];
      }
      grouped[streamNumber].push(obj);
    });
    return grouped;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getScFailedOrCirObject(group) {
    // Flag to track if the first percentage fail object has been pushed
    let firstPercentageFailPushed = false;

    // Iterate through the group and collect necessary objects
    for (let i = 0; i < group.length; i++) {
      const stepName = group[i]['step-name'];
      const verdict = group[i].verdict;
      const isPercentageStepName = /\d+%/.test(stepName);

      if (stepName === 'eir') {
        this.eirScObject = group[i];
      } else if (stepName === 'Traffic Policing') {
        this.policingScObject = group[i];
      }

      // Push the object if it meets the conditions
      if (
        (!firstPercentageFailPushed && verdict === 'fail' && isPercentageStepName) ||
        (!firstPercentageFailPushed && stepName === 'cir' && verdict === 'fail')
      ) {
        this.groupedReportForSc.push(group[i]);
        firstPercentageFailPushed = true; // Set flag to true after pushing the first percentage fail object
      } else if ((stepName === 'cir' && verdict === 'pass') || verdict === 'pass') {
        this.groupedReportForSc.push(group[i]);
      }
    }

    // Ensure eir and Traffic Policing objects are included if they exist
    if (this.eirScObject && !this.groupedReportForSc.includes(this.eirScObject)) {
      this.groupedReportForSc.push(this.eirScObject);
    }
    if (this.policingScObject && !this.groupedReportForSc.includes(this.policingScObject)) {
      this.groupedReportForSc.push(this.policingScObject);
    }

    this.cirObjectList();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getSpFailedOrCirObject(group) {
    this.groupedReportForSp.push(group[0]);
    this.uniqueSpArray = this.removeDuplicateCirObjects(this.groupedReportForSp);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  cirObjectList() {
    if (this.groupedReportForSc.length > 0) {
      // If cir objects include failed ones and eir object is present, add eir object to the array
      if (
        this.groupedReportForSc.some(obj => obj.verdict === 'fail' || obj.verdict === 'pass') &&
        this.eirScObject
      ) {
        this.groupedReportForSc.push(this.eirScObject);
      }
      if (
        this.groupedReportForSc.some(obj => obj.verdict === 'fail' || obj.verdict === 'pass') &&
        this.policingScObject
      ) {
        this.groupedReportForSc.push(this.policingScObject);
      }
      this.uniqueScArray = this.removeDuplicateCirObjects(this.groupedReportForSc);
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  removeDuplicateCirObjects(array) {
    const uniqueObjects = {};

    // Iterate through the array
    for (const obj of array) {
      if (obj['step-name']) {
        // Check if the object's step-name is 'eir'
        if (obj['step-name'] === 'eir') {
          // If step-name is 'eir', add it to the uniqueObjects without checking for duplicates
          uniqueObjects[`${obj['stream-number']}-eir`] = obj;
        } else if (obj['step-name'] === 'Traffic Policing') {
          // If step-name is 'eir', add it to the uniqueObjects without checking for duplicates
          uniqueObjects[`${obj['stream-number']}-Traffic Policing`] = obj;
        } else {
          // If step-name is not 'eir', check for duplicates based on stream-number and step-name
          const key = `${obj['stream-number']}-${obj['step-name']}`;
          if (!uniqueObjects[key]) {
            // If the key doesn't exist, add the object to the uniqueObjects
            uniqueObjects[key] = obj;
          }
        }
      } else {
        const key = `${obj['stream-number']}`;
        if (!uniqueObjects[key]) {
          // If the key doesn't exist, add the object to the uniqueObjects
          uniqueObjects[key] = obj;
        }
      }
    }

    // Convert uniqueObjects back to an array
    const uniqueArray = Object.values(uniqueObjects);
    return uniqueArray;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  trendCharts() {
    this.rptSamplesReceived = 0;
    this.trendChartsData = true;
    this.getTrendingData();
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getTrendingData() {
    this.trendingInProgress = true;
    this.trendingMsg = 'Checking sample availability...';
    this.chartSeriesConfig[0].name = this.getStreamRateChartType();

    // if( UIComm.isAuthenticated() ) {
    const opt = {
      scheduleId: this.scheduleId,
      reportType: 'rt',
      runid: this.runId
    };

    if (this.onDemandTest) {
      this.collectorApiService
        .getReportCount(opt)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe(
          response => {
            if (this.log === true) {
              console.log('RT Report Count: response: + ' + JSON.stringify(response));
            }

            const errorMsg = this.helperService.getResponseErrorMsg(response);

            if (errorMsg == null) {
              if (response.data) {
                if (response.data.results) {
                  this.rptSamplesNeeded = response.data.results;
                  this.trendingMsg =
                    'Retrieving ' +
                    this.helperService.addCommas(this.rptSamplesNeeded.toString()) +
                    ' samples';

                  this.getReports(this.reportStartTime);
                }
              } else {
                console.log('ERROR: response.data does not exist in RT Report Count response');
              }
            } else {
              console.log('ERROR: RT Report Count Failed because : ' + errorMsg);
            }
          },
          () => {
            this.trendingMsg = 'No data found';
          }
        );
    } else {
      this.rptSamplesNeeded = this.perTestDuration;
      this.getReports(this.reportStartTime);
    }
    // } else {
    //     console.log("ERROR: Get Report Count not performed because UIComm is not connected");
    // }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getReports(fromTime) {
    if (this.trendingInProgress === false) {
      console.log('Trending aborting #1'); //view destroyed
      return;
    }

    this.rptRequestCtr++;

    const opt = {
      scheduleId: this.scheduleId,
      reportType: 'rt',
      runid: this.runId,
      maxresults: 0,
      fromtime: fromTime
    };

    opt.maxresults = this.rptBatchSize;
    if (typeof fromTime != 'undefined') {
      opt.fromtime = fromTime;
    }

    console.log(
      new Date().toLocaleTimeString() + '  REQUESTING REPORT BATCH: ' + this.rptRequestCtr
    );

    if (this.log === true) {
      console.log('******************************');
      console.log('getReports');
      console.log('Request: ' + this.rptRequestCtr);
      console.log('Schedule ID: ' + opt.scheduleId);
      console.log('Run ID: ' + opt.runid);
      if (opt.fromtime) {
        console.log('Requesting From Time: ' + opt.fromtime);
      }
      console.log('Max Results: ' + opt.maxresults);
      console.log('******************************');
    }

    this.rptStartRequestTime = new Date();

    this.collectorApiService
      .getQueryReportByFromTime(this.scheduleId, this.runId, 'rt', fromTime, this.rptBatchSize)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(
        response => {
          const getRTResultResponse = response.data.filter(data => {
            const instanceStartTime = this.lmapService.getTagValue(
              data['ietf-lmap-report:report'].result[0].tag,
              'instance-start-time'
            );
            return instanceStartTime === this.reportStartTime;
          });
          this.processReportBatch({ data: getRTResultResponse });
        },
        () => {
          this.trendingMsg = 'No data found';
        }
      );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processReportBatch(response): void {
    if (this.log === true) {
      console.log(new Date().toLocaleTimeString() + ' Batch arrived');
    }

    if (this.trendingInProgress === false) {
      console.log('Trending aborting #2'); //view destroyed
      return;
    }

    // Check response to make sure it is valid
    const errorMsg = this.helperService.getResponseErrorMsg(response);

    if (errorMsg == null) {
      if (response) {
        const responseData = response.data;
        // If number of samples returned = number requested, request more using postTime
        // from last sample as starting time for next request

        this.rptLastSampleDate = '';

        // debug info
        let samplesInThisBatch = 0;
        let firstSampleDate = '';
        let firstSampleTag = '';
        let lastSampleTag = '';

        if (responseData.length && responseData.length > 0) {
          samplesInThisBatch = responseData.length;
          firstSampleDate = this.lmapService.getReportPostDate(response, 0);
          firstSampleTag = this.lmapService.getReportTag(response, 0);
          this.rptLastSampleDate = this.lmapService.getReportPostDate(
            response,
            responseData.length - 1
          );
          lastSampleTag = this.lmapService.getReportTag(response, responseData.length - 1);
        }
        this.rptSamplesReceived += samplesInThisBatch;

        const allRtReport = responseData;

        for (let i = allRtReport.length - 1; i >= 0; i--) {
          const report = this.lmapService.ltranslateLmapReportIndexToAngular(allRtReport, null, i);
          if (!report) continue; // Ensure report is valid
        
          for (const reportEntry of report) {
            if (
              reportEntry &&
              reportEntry['status'] &&
              reportEntry['frame-loss-ratio'] &&
              reportEntry['originator'] &&
              reportEntry['stream-number']
            ) {
              if (reportEntry['status'].indexOf('RUNNING_PERF_TEST') < 0) continue;       
              if (reportEntry['frame-loss-ratio'] < 0) continue;
              else if (reportEntry['frame-loss-ratio'] > 1) {
                reportEntry['frame-loss-ratio'] = 1;
                continue;
              }    
              const reportStreamName = reportEntry?.['stream-name'];
              const originator = reportEntry?.originator;  
              reportEntry['frame-loss-ratio'] = this.getFLRValue(reportEntry);

              for (let si = 0; si < this.streams.length; si++) {
                const streamName = this.streams[si].name;
                if (streamName === reportStreamName) {
                  const timeStamp = new Date(reportEntry['postDate']).getTime();
                  if (originator) {
                    this.updateSPDataSource(si, reportEntry, originator, timeStamp, 'previousItem');
                  }
                  break;
                }
              }
            }
          }
        }
        const currentTime: any = new Date();
        const elapsedTime = currentTime.getTime() - this.rptStartRequestTime.getTime();
        this.rptTotalTime += elapsedTime;

        if (this.log === true) {
          console.log('**********************************');
          console.log('Request: ' + this.rptRequestCtr);
          console.log('Reports: ' + samplesInThisBatch);
          console.log('Date of first sample: ' + firstSampleDate);
          console.log('Tag of first sample: ' + firstSampleTag);
          console.log('Date of last sample: ' + this.rptLastSampleDate);
          console.log('Tag of last sample: ' + lastSampleTag);
          console.log('Time to get this request (ms): ' + elapsedTime);
          console.log('Total Reports Received: ' + this.rptSamplesReceived);
          console.log('Total Time (ms): ' + this.rptTotalTime);
          console.log('**********************************');
        }

        if (this.rptBatchSize === samplesInThisBatch) {
          if (this.rptSamplesNeeded > 0) {
            const percentComplete = parseInt(
              ((this.rptSamplesReceived / this.rptSamplesNeeded) * 100).toString()
            );
            if (this.log === true) {
              console.log('Percent Complete: ' + percentComplete);
            }
            this.trendingMsg =
              'Retrieving ' +
              this.helperService.addCommas(this.rptSamplesNeeded.toString()) +
              ' samples (' +
              percentComplete +
              '%)';
            this.trendingPercent = percentComplete;
          }

          this.rptRequestRetries = 0; //reset for new request

          if (this.log === true) {
            console.log(new Date().toLocaleTimeString() + ' Batch done processing');
          }
          setTimeout(() => {
            this.getReports(this.rptLastSampleDate);
          }, this.rptTimeOutMs);
        } else {
          if (this.rptSamplesNeeded > 0) {
            this.trendingMsg =
              'Retrieved ' +
              this.helperService.addCommas(this.rptSamplesNeeded.toString()) +
              ' samples (100%)';
          } else {
            this.trendingMsg = 'Retrieving samples complete';
          }
          this.trendingPercent = 100;
          this.trendingComplete = true;

          if (this.log === true) {
            console.log(new Date().toLocaleTimeString() + ' ** ALL SAMPLES PROCESSED **');
            for (let x = 0; x < this.trendingResults.length; x++) {
              console.log('**********************************');
              console.log('Stream: ' + this.trendingResults[x].name);
              console.log('FLR 2way: ' + this.trendingResults[x].flr2wayCur.length);
              console.log('FLR NF: ' + this.trendingResults[x].flrNFCur.length);
              console.log('FLR FN: ' + this.trendingResults[x].flrFNCur.length);
              console.log('**********************************');
            }
          }
          this.processSPData();

          setTimeout(function () {
            this.priorTrendingReportsProcessed = true;
          }, this.rptTimeOutMs); // let IE breathe
        }
      }
    } else {
      if (response.data && response.data.code && response.data.code === 408) {
        if (this.rptRequestRetries < this.rptMaxRequestRetries) {
          this.rptRequestRetries++;
          console.log(
            'processReportBatch Retrying for : ' +
              this.rptLastSampleDate +
              ' ,attempt ' +
              this.rptRequestRetries
          );
          this.rptRequestCtr--;
          setTimeout(function () {
            this.getReports(this.rptLastSampleDate);
          }, this.rptTimeOutMs);
        } else {
          console.log('processReportBatch giving up for ' + this.rptLastSampleDate);
          alert('Aborting trend chart creation because the request for data timed out repeatedly.');
        }
      } else {
        alert(
          'Aborting the trend chart creation because the attempt to retrieve data returned the message: ' +
            errorMsg +
            '.'
        );
      }
    }
  }

  initializePeformanceData(): void {
    this.streams.forEach((data, index) => {
      this.performanceData[index] = {
        name: data.name,
        engineAData: {
          dataSourceItems: [],
          dataSource: new BehaviorSubject<any>({ noValue: true })
        },
        engineBData: {
          dataSourceItems: [],
          dataSource: new BehaviorSubject<any>({ noValue: true })
        },
        rxCount: '',
        frameLossCount: '',
        streamConfig: '',
        frameSize: '',
        vlanPriority: '',
        dscp: ''
      };
    });
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  updateSPDataSource(
    index: number,
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    rtData: any,
    engineName: string,
    timestamp: number,
    update: string
  ): void {
    const engineField = engineName === 'ENGINE_A' ? 'engineAData' : 'engineBData';
    if (update === 'previousItem') {
      this.performanceData[index][engineField].dataSourceItems.unshift({
        timestamp: timestamp,
        data: rtData
      });
    } else {
      this.performanceData[index][engineField].dataSourceItems.push({
        timestamp: timestamp,
        data: rtData
      });
    }

    // this.performanceData[index][engineField].dataSource.next(
    //   this.performanceData[index][engineField].dataSourceItems
    // );
  }

  processSPData(): void {
    this.performanceData.forEach(data => {
      const engineAData = data.engineAData.dataSourceItems.sort((a, b) => {
        return a.timestamp - b.timestamp;
      });
      const engineBData = data.engineBData.dataSourceItems.sort((a, b) => {
        return a.timestamp - b.timestamp;
      });
      data.engineAData.dataSource.next(engineAData);
      data.engineBData.dataSource.next(engineBData);
    });
    // this.performanceData[index][engineField].dataSource.next(
    //   this.performanceData[index][engineField].dataSourceItems
    // );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  adjustThruput(thruobj: any): any {
    thruobj.units = 'Mbps';
    if (thruobj.tp >= 1000) {
      thruobj.tp = thruobj.tp / 1000;
      thruobj.units = 'Gbps';
    }
    thruobj.tp = Math.round(thruobj.tp * 100) / 100;
  }

  //eslint-disable-next-line
  getFLRValue(report: any): any {
    let flr: any = '--';
    this.trendingInfoAvailable = true;
    if (report['frame-loss-ratio']) {
      flr = parseFloat(report['frame-loss-ratio']);

      if (flr === -1.0 && report['frame-loss-count'] === '-1') {
        flr = 0; // changing '--' to '0' because of on first rt response flr value '-1' graph is not showing and it's effecting to other graphs alignment.
        this.trendingInfoAvailable = false;
      } else if (flr <= 0) {
        flr = 0;
      }
      // Only convert flr to percentage if agent is not a JMEP, otherwise, display value JMEP provides
      else if (
        this.testConfig &&
        this.testConfig['viavi-solutions-y1564:y1564'] &&
        this.testConfig['viavi-solutions-y1564:y1564']['engine-a-info'] &&
        this.testConfig['viavi-solutions-y1564:y1564']['engine-a-info']['engine-type'] &&
        this.testConfig['viavi-solutions-y1564:y1564']['engine-a-info']['engine-type'].indexOf(
          'JMEP'
        ) < 0
      ) {
        if (flr > 1) {
          flr = 100;
        } else {
          flr = flr * 100;
          flr = Math.round(flr * 10) / 10;
        }
      }
    }
    return flr;
  }

  hasInvalidData(seriesData: any[]): boolean {
    return seriesData?.some(
      series => !series.data || series.data.every(value => value === undefined || isNaN(value))
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  processData(data, originator) {
    // Helper function to format number to two decimal places
    const formatToTwoDecimalPlaces = num => parseFloat(parseFloat(num).toFixed(2));

    // Helper function to filter out NaN values
    const filterNaN = arr => arr.filter(num => !isNaN(num));

    // Process data for IR chart
    const irCategories = ['Overall', ...data.map(item => item['stream-name'])];
    let overallMin = 0;
    let overallAvg = 0;
    let overallMax = 0;
    let overallCir = 0;

    data.forEach(service => {
      overallMin += formatToTwoDecimalPlaces(service['ir-min']);
      overallAvg += formatToTwoDecimalPlaces(service['ir-avg']);
      overallMax += formatToTwoDecimalPlaces(service['ir-max']);
      overallCir += formatToTwoDecimalPlaces(service['target-ir']);
    });

    const irSeriesData = [
      {
        name: 'Min',
        data: filterNaN([
          formatToTwoDecimalPlaces(overallMin),
          ...data.map(item => formatToTwoDecimalPlaces(item['ir-min']))
        ])
      },
      {
        name: 'Average',
        data: filterNaN([
          formatToTwoDecimalPlaces(overallAvg),
          ...data.map(item => formatToTwoDecimalPlaces(item['ir-avg']))
        ])
      },
      {
        name: 'Max',
        data: filterNaN([
          formatToTwoDecimalPlaces(overallMax),
          ...data.map(item => formatToTwoDecimalPlaces(item['ir-max']))
        ])
      },
      {
        name: 'CIR',
        data: filterNaN([
          formatToTwoDecimalPlaces(overallCir),
          ...data.map(item => formatToTwoDecimalPlaces(item['target-ir']))
        ])
      }
    ];

    // Process data for FL chart
    const flCategories = data.map(item => item['stream-name']);
    const flSeriesData = [
      {
        name: 'Average',
        data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['frame-loss-ratio'])))
      },
      {
        name: 'Peak',
        data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['peak-frame-loss-ratio'])))
      },
      {
        name: 'SLA',
        data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['frame-loss-sla'])))
      }
    ];

    // Process data for FD chart
    const fdCategories = data.map(item => item['stream-name']);
    const fdSeriesData = [
      { name: 'Min', data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['fd-min']))) },
      {
        name: 'Average',
        data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['fd-avg'])))
      },
      { name: 'Max', data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['fd-max']))) },
      { name: 'SLA', data: filterNaN(data.map(item => formatToTwoDecimalPlaces(item['fd-sla']))) }
    ];

    // Process data for FD Distribution chart
    const fdDistributionSeriesData = data.map(item => ({
      name: item['stream-name'],
      data: filterNaN([
        formatToTwoDecimalPlaces(item['fd-lt-2ms']),
        formatToTwoDecimalPlaces(item['fd-2ms-to-4ms']),
        formatToTwoDecimalPlaces(item['fd-4ms-to-8ms']),
        formatToTwoDecimalPlaces(item['fd-8ms-to-16ms']),
        formatToTwoDecimalPlaces(item['fd-16ms-to-32ms']),
        formatToTwoDecimalPlaces(item['fd-32ms-to-64ms']),
        formatToTwoDecimalPlaces(item['fd-gt-64ms'])
      ])
    }));

    // Process data for FDV chart
    const fdvCategories = data.map(item => item['stream-name']);
    const fdvSeriesData = [
      { name: 'Average', data: filterNaN(data.map(item => parseFloat(item['fdv-avg']))) },
      { name: 'Max', data: filterNaN(data.map(item => parseFloat(item['fdv-max']))) },
      { name: 'SLA', data: filterNaN(data.map(item => parseFloat(item['fdv-sla']))) }
    ];

    const chartData = {
      irCategories,
      irSeriesData,
      flCategories,
      flSeriesData,
      fdCategories,
      fdSeriesData,
      fdDistributionSeriesData,
      fdvCategories,
      fdvSeriesData
    };

    if (originator === 'engine-a') {
      this.engineACharts = chartData;
    } else if (originator === 'engine-b') {
      this.engineBCharts = chartData;
    } else {
      this.singleEngineCharts = chartData;
    }

    // Check if any chart data is valid using the new helper function
    const isEngineAValid = this.isChartDataValid(this.engineACharts);
    const isEngineBValid = this.isChartDataValid(this.engineBCharts);
    const isSingleEngineValid = this.isChartDataValid(this.singleEngineCharts);
    // If any chart data is valid, showCharts will be true
    this.showCharts = isEngineAValid || isEngineBValid || isSingleEngineValid;
  }

  // Helper function to check if any of the chart data is valid
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  isChartDataValid(chartData: any): boolean {
    return (
      (chartData?.irSeriesData && !this.hasInvalidData(chartData.irSeriesData)) ||
      (chartData?.flSeriesData && !this.hasInvalidData(chartData.flSeriesData)) ||
      (chartData?.fdSeriesData && !this.hasInvalidData(chartData.fdSeriesData)) ||
      (chartData?.fdDistributionSeriesData &&
        !this.hasInvalidData(chartData.fdDistributionSeriesData)) ||
      (chartData?.fdvSeriesData && !this.hasInvalidData(chartData.fdvSeriesData))
    );
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  testConfigDisplayData() {
    const streams =
      this.y1564TestConfig?.['viavi-solutions-y1564:y1564']?.['group']?.[0]?.['streams'];
    if (this.overallConfiguration && this.overallConfiguration.test) {
      if (this.overallConfiguration.test['extended-config']) {
        this.uiConfig = this.overallConfiguration.test['extended-config'];
        this.testListData = this.overallConfiguration.test['test-list-data'].tpInfo[0].ip;

        // build a list of UI configured streams that can be used to build a better
        // report - only include the enabled ones so the stream numbers align with the MA's report
        if (
          this.uiConfig &&
          this.uiConfig.pluginConfig &&
          this.uiConfig.pluginConfig.connections &&
          this.uiConfig.pluginConfig.connections.connections[0] &&
          this.uiConfig.pluginConfig.connections.connections[0].streams
        ) {
          const cstreams = this.uiConfig.pluginConfig.connections.connections[0].streams;
          for (let stIdx = 0, stLen = cstreams.length; stIdx < stLen; ++stIdx) {
            // if(cstreams[stIdx].strmInUse === 'true') {
            this.uiStreams.push(cstreams[stIdx]);
            // }
          }
        }
        if (
          this.uiConfig &&
          this.uiConfig.testPoints &&
          this.uiConfig.testPoints.length &&
          this.uiConfig.testPoints.length > 0
        ) {
          for (let x = 0; x < this.uiConfig.testPoints.length; x++) {
            if (this.uiConfig.testPoints[x].name === this.overallConfiguration.agent.primary.id) {
              if (this.uiConfig.testPoints[x].version) {
                this.testConfigDisplay.tpaVersion = this.uiConfig.testPoints[x].version;
              }
            } else if (
              this.overallConfiguration.agent.secondary &&
              this.overallConfiguration.agent.secondary.length &&
              this.overallConfiguration.agent.secondary.length > 0 &&
              this.uiConfig.testPoints[x].name === this.overallConfiguration.agent.secondary[0].id
            ) {
              this.testConfigDisplay.tpbVersion = this.uiConfig.testPoints[x].version;
            }
          }
        }
      }

      if (
        this.overallConfiguration.test['test-list-data'] &&
        this.overallConfiguration.test['test-list-data'].layer
      ) {
        if (this.overallConfiguration.test['test-list-data'].layer == 'L2') {
          this.layer = 'Layer 2';
        } else if (this.overallConfiguration.test['test-list-data'].layer == 'L3') {
          this.layer = 'Layer 3';
        }
      }
    } else {
      if (streams) {
        for (let stIdx = 0, stLen = streams.length; stIdx < stLen; ++stIdx) {
          // if(cstreams[stIdx].strmInUse === 'true') {
          this.uiStreams.push(streams[stIdx]);
          // }
        }
      }
      if (this.overallConfiguration?.agent?.primary?.id) {
        const deviceId = this.overallConfiguration?.agent?.primary?.id;
        const device = this.deviceService.findDeviceByUniqueName(deviceId);
        this.testConfigDisplay.tpaVersion = device?.['deviceData']?.['model']?.['version'];
      }
      if (this.overallConfiguration?.agent?.secondary) {
        const deviceId = this.overallConfiguration?.agent?.secondary?.[0]?.id;
        const device = this.deviceService.findDeviceByUniqueName(deviceId);
        this.testConfigDisplay.tpbVersion = device?.['deviceData']?.['model']?.['version'];
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createOverallTestSetup() {
    let parms = null;
    if (
      (this.y1564TestConfig && this.y1564TestConfig['y1564:y1564']) ||
      (this.y1564TestConfig && this.y1564TestConfig['viavi-solutions-y1564:y1564'])
    ) {
      if (
        this.y1564TestConfig &&
        this.y1564TestConfig['y1564:y1564'] &&
        this.y1564TestConfig['y1564:y1564']['y1564-parameters']
      ) {
        parms = this.y1564TestConfig['y1564:y1564']['y1564-parameters'];
      } else if (
        this.y1564TestConfig &&
        this.y1564TestConfig['viavi-solutions-y1564:y1564'] &&
        this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters']
      ) {
        parms = this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'];
      }
      // we want to control the display order so look up each setting instead of iterating
      if (parms['mode']) {
        this.testMode = parms['mode']; // store for quick reference
        if (this.testModeArray[parms['mode']]) {
          this.testConfigDisplay.overall.push({
            name: 'Test Mode',
            value: this.testModeArray[parms['mode']]
          });
        } else {
          this.testConfigDisplay.overall.push({ name: 'Test Mode', value: parms['mode'] });
        }
      } else {
        this.testConfigDisplay.overall.push({ name: 'Test Mode', value: 'Loopback' });
      }
      if (parms['ip-address-type']) {
        if (parms['ip-address-type'] === 'ipv4') {
          this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV4' });
        } else {
          this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV6' });
        }
      } else {
        this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV4' }); //layer 2 is default in model
      }

      if (parms['layer']) {
        if (parms['layer'] === 'L2') {
          this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 2' });
          if (parms['swap-addresses']) {
            this.testConfigDisplay.overall.push({ name: 'Swap Mac Addresses', value: 'Enabled' });
          } else {
            this.testConfigDisplay.overall.push({ name: 'Swap Mac Addresses', value: 'Disabled' });
          }
        } else if (parms['layer'] === 'L3') {
          this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 3' });
          this.layerToTest = '3'; // store for quick reference
        } else {
          this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: parms['layer'] });
          this.layerToTest = parms['layer'];
        }
      } else {
        this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 2' }); //layer 2 is default in model
      }

      // The probe only accepts bandwidth in ULR. If we have UI data and it says they selected IR, show it here
      // and then when we display CIR, EIR and Excess Allowed for the streams will will use the UI data
      if (parms['unit-convention'] === 'l1-mbps') {
        this.streamRateConvention = 'L1 Mbps (ULR)';
        this.streamRateValue = 'l1-mbps';
      } else if (parms['unit-convention'] === 'l2-mbps') {
        this.streamRateConvention = 'L2 Mbps (IR)';
        this.streamRateValue = 'l2-mbps';
      } else if (
        this.uiConfig &&
        this.uiConfig.pluginConfig &&
        this.uiConfig.pluginConfig.setup &&
        this.uiConfig.pluginConfig.setup.bandwidthConvention &&
        this.uiConfig.pluginConfig.setup.bandwidthConvention === 'ir'
      ) {
        this.streamRateConvention = 'L2 Mbps (IR)';
        this.streamRateValue = 'l2-mbps';
      } else if (
        this.uiConfig &&
        this.uiConfig.pluginConfig &&
        this.uiConfig.pluginConfig.setup &&
        this.uiConfig.pluginConfig.setup.bandwidthConvention &&
        this.uiConfig.pluginConfig.setup.bandwidthConvention === 'ulr'
      ) {
        this.streamRateConvention = 'L1 Mbps (ULR)';
        this.streamRateValue = 'l1-mbps';
      }
      this.testConfigDisplay.overall.push({
        name: 'Stream Rate Convention',
        value: this.streamRateConvention
      });

      this.scEnabled = false; //default in model is false

      if (parms['run-config-test'] === true) {
        this.scEnabled = true;
      }

      if (this.scEnabled === true) {
        this.testConfigDisplay.overall.push({
          name: 'Service Configuration Test',
          value: 'Enabled'
        });
        if (parms['step-percents']) {
          let displayVal = '';
          const steps = parms['step-percents'];
          for (const x in steps) {
            if (displayVal.length > 0) {
              displayVal += ' ';
            }
            displayVal += steps[x] + '%';
          }
          if (displayVal.length > 0) {
            displayVal += ' ';
          }
          displayVal += '100%';
          this.testConfigDisplay.overall.push({ name: 'Steps', value: displayVal });
        } else {
          this.testConfigDisplay.overall.push({ name: 'Steps', value: '100%' });
        }

        if (parms['step-duration']) {
          this.testConfigDisplay.overall.push({
            name: 'Step Duration',
            value: parms['step-duration'] + ' seconds'
          });
        } else {
          this.testConfigDisplay.overall.push({ name: 'Step Duration', value: 'unknown' }); // no default in model
        }
      } else {
        this.testConfigDisplay.overall.push({
          name: 'Service Configuration Test',
          value: 'Disabled'
        });
      }

      this.spEnabled = true; //default in model is true

      if (parms['run-perf-test'] === false) {
        this.spEnabled = false;
      }

      if (this.spEnabled === true) {
        this.testConfigDisplay.overall.push({ name: 'Service Performance Test', value: 'Enabled' });
        if (parms['perf-test-duration']) {
          const displayValue = this.helperService.convertSecondsToHMS(parms['perf-test-duration']);
          /*if (displayValue && typeof displayValue === 'string') {
                    displayValue = displayValue.replace(':', 'h ');
                    displayValue = displayValue.replace(':', 'm ');
                    displayValue += 's';
                }*/
          this.testConfigDisplay.overall.push({
            name: 'Performance Test Duration (HH:MM:SS)',
            value: displayValue
          });
        } else {
          // default in model is 60 secs
          this.testConfigDisplay.overall.push({
            name: 'Performance Test Duration (HH:MM:SS)',
            value: '00:01:00'
          });
        }
      } else {
        this.testConfigDisplay.overall.push({
          name: 'Service Performance Test',
          value: 'Disabled'
        });
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  getVerdictReason(response, reportType) {
    let tags = '';
    let testState = '';
    let verdictReason = '';
    for (let i = 0; i < response.data.length; i++) {
      tags = this.lmapService.getReportTag(response, i);
      testState = this.lmapService.getTagValue(tags, 'table-type');
      if (testState == reportType) {
        verdictReason = this.lmapService.getTagValue(tags, 'verdict-reason');
        this.versionValue = this.lmapService.getTagValue(tags, 'result-format');
        return verdictReason;
      }
    }

    return verdictReason;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  produceErrorObj(finalReport) {
    let errMsg = null;
    let errorCount = 0;
    let flrErrorCount = 0;
    let fdErrorCount = 0;
    let fdvErrorCount = 0;
    let eirErrorCount = 0;
    let policingErrorCount = 0;
    let firstFailedStreamNum = null;
    let multipleStreamsFailed = false;
    let verdictReason = '';
    if (finalReport != null) {
      for (let i = 0, len = finalReport.length; i < len; ++i) {
        let flrFailed = false;
        let fdFailed = false;
        let fdvFailed = false;
        const report = finalReport[i];
        if (report['verdict'] === 'fail') {
          errorCount++;
          if (firstFailedStreamNum === null) {
            firstFailedStreamNum = report['stream-number'];
            console.log(firstFailedStreamNum);
            verdictReason = report['verdict-reason'];
          } else {
            if (firstFailedStreamNum !== report['stream-number']) {
              multipleStreamsFailed = true;
            }
          }
          if (report['flr-verdict'] === 'fail') {
            flrFailed = true;
            flrErrorCount++;
          }
          if (report['fd-verdict'] === 'fail') {
            fdFailed = true;
            fdErrorCount++;
          }
          if (report['fdv-verdict'] === 'fail') {
            fdvFailed = true;
            fdvErrorCount++;
          }
          // if the stream failed the ramps, CIR or SP test is should be due to FLR or FD or FDV
          // if the stream failed EIR or Policing and it wasn't due to FLR or FD then report this specifically
          if (
            flrFailed === false &&
            fdFailed === false &&
            fdvFailed === false &&
            report['step-name'] &&
            typeof report['step-name'] === 'string'
          ) {
            if (report['step-name'].toLowerCase().indexOf('eir') >= 0) {
              eirErrorCount++;
            } else if (report['step-name'].toLowerCase().indexOf('policing') >= 0) {
              policingErrorCount++;
            }
          }
        }
      }
    }

    // Produce an error message

    if (errorCount > 0) {
      let reason = '';
      if (multipleStreamsFailed === true) {
        errMsg = 'Multiple test failures occurred. Please review report for more details';
      } else if (firstFailedStreamNum !== null) {
        errMsg = this.getErrorStreamName(firstFailedStreamNum);
        reason = verdictReason || '';
      }

      if (!reason) {
        if (flrErrorCount > 0) {
          reason += ' Frame loss threshold exceeded';
        }
        if (fdErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'FTD exceeded';
        }
        if (fdvErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'FDV exceeded';
        }
        if (eirErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'EIR step';
        }
        if (policingErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'Policing step';
        }
      }
      errMsg += ' failed' + (reason ? ' - ' : '') + reason;
    }
    return errMsg;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createRequestInfo(data: any): any {
    const requestInfo = {};
    if (data && data.test && data.test['extended-config']) {
      requestInfo['techInfo'] = data.test['extended-config'].technicianInfo;
      requestInfo['testName'] = data.test['extended-config'].testInfo.name;
      requestInfo['mode'] = data.test['extended-config'].test.mode.toUpperCase();
      requestInfo['comments'] = data.test['extended-config'].testInfo.comments;
    } else {
      requestInfo['mode'] = this.testMode?.toUpperCase();
      requestInfo['testName'] =
        this.overallConfiguration?.['config']?.[0]?.['primaryConfig']?.['ietf-lmap-control:lmap']?.[
          'schedules'
        ]?.['schedule']?.[0]?.name;
    }

    if (data && data.test && data.test['test-list-data']) {
      requestInfo['customerInfo'] = data.test['test-list-data'].customer;
      requestInfo['mode'] = this.testMode?.toUpperCase();
    }
    const primaryUrl = this.helperService.createPublicAccessURL(this.serverConfig, this.shaId);
    const secondaryUrl = this.helperService.generateSecondaryTestURL(
      this.serverConfig,
      this.shaId,
      this.selectedOriginator
    );
    requestInfo['expirationDate'] = this.helperService.getReportDateTimeString(
      data?.test?.controller?.['expiration-date']
    );
    requestInfo['dmzUrl'] = primaryUrl ? primaryUrl + '&type=' + this.activeLicense : '';
    requestInfo['vtaTsUrl'] = secondaryUrl ? secondaryUrl + '&type=' + this.activeLicense : '';
    let agentName = data && data && data.agent && data.agent.primary ? data.agent.primary.id : null;
    if (!agentName) {
      agentName =
        data &&
        data &&
        data.test &&
        data.test['extended-config'] &&
        data.test['extended-config'].testPoints &&
        data.test['extended-config'].testPoints > 0
          ? data.test['extended-config'].testPoints[0].name
          : null;
    }
    return requestInfo;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createOverallQTTestSetup() {
    if (
      (this.testConfig &&
        this.testConfig['y1564:y1564'] &&
        this.testConfig['y1564:y1564']['y1564-parameters']) ||
      (this.testConfig['viavi-solutions-y1564:y1564'] &&
        this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters'])
    ) {
      let parms;
      if (this.testConfig['y1564:y1564']) {
        parms = this.testConfig['y1564:y1564']['y1564-parameters'];
      } else if (this.testConfig['viavi-solutions-y1564:y1564']) {
        parms = this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters'];
      }

      // we want to control the display order so look up each setting instead of iterating
      if (parms['mode']) {
        this.testMode = parms['mode']; // store for quick reference
        if (this.testModeArray[parms['mode']]) {
          this.testConfigDisplay.overall.push({
            name: 'Test Mode',
            value: this.testModeArray[parms['mode']]
          });
        } else {
          this.testConfigDisplay.overall.push({ name: 'Test Mode', value: parms['mode'] });
        }
      } else if (this.qtVersion === 'v2') {
        this.testConfigDisplay.overall.push({ name: 'Test Mode', value: 'Loopback' }); //test mode has default in model
      } else {
        this.testConfigDisplay.overall.push({ name: 'Test Mode', value: 'unknown' }); //test mode has no default in model
      }

      if (parms['layer']) {
        if (parms['layer'] === 'L2') {
          this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 2' });
        } else if (parms['layer'] === 'L3') {
          this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 3' });
          this.layerToTest = '3'; // store for quick reference
        } else {
          this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: parms['layer'] });
          this.layerToTest = parms['layer'];
        }
      } else {
        this.testConfigDisplay.overall.push({ name: 'Layer to Test', value: 'Layer 2' }); //layer 2 is default in model
      }

      // The probe only accepts bandwidth in ULR. If we have UI data and it says they selected IR, show it here
      // and then when we display CIR, EIR and Excess Allowed for the streams will will use the UI data
      if (parms['unit-convention'] === 'l1-mbps') {
        this.streamRateConvention = 'L1 Mbps (ULR)';
        this.streamRateValue = 'l1-mbps';
      } else if (parms['unit-convention'] === 'l2-mbps') {
        this.streamRateConvention = 'L2 Mbps (IR)';
        this.streamRateValue = 'l2-mbps';
      } else if (
        this.uiConfig &&
        this.uiConfig.pluginConfig &&
        this.uiConfig.pluginConfig.setup &&
        this.uiConfig.pluginConfig.setup.bandwidthConvention
      ) {
        if (this.uiConfig.pluginConfig.setup.bandwidthConvention === 'ir') {
          this.streamRateConvention = 'L2 Mbps (IR)';
          this.streamRateValue = 'l2-mbps';
        }
      } else if (this.qtVersion === 'v2') {
        // default If there is no streamRateConvention in the test config
        this.streamRateConvention = 'L2 Mbps (IR)';
        this.streamRateValue = 'l2-mbps';
      }

      if (
        this.uiConfig?.pluginConfig &&
        this.uiConfig?.pluginConfig?.setup &&
        this.uiConfig?.pluginConfig?.setup?.suppressLoopCommands
      ) {
        this.testConfigDisplay.overall.push({
          name: 'Suppress Loop Commands',
          value: this.uiConfig.pluginConfig.setup.suppressLoopCommands
        });
      } else if (parms['suppress-loop-commands'] || !parms['suppress-loop-commands']) {
        this.testConfigDisplay.overall.push({
          name: 'Suppress Loop Commands',
          value: parms['suppress-loop-commands']
        });
      }
      if (
        this.uiConfig?.pluginConfig &&
        this.uiConfig?.pluginConfig?.setup &&
        this.uiConfig?.pluginConfig?.setup?.ipAddrType
      ) {
        if (this.uiConfig.pluginConfig.setup.ipAddrType === 'ipv4') {
          this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV4' });
        } else {
          this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV6' });
        }
      } else if (parms['ip-address-type']) {
        if (parms['ip-address-type'] === 'ipv4') {
          this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV4' });
        } else {
          this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV6' });
        }
      } else {
        this.testConfigDisplay.overall.push({ name: 'IP Address Type', value: 'IPV4' }); //layer 2 is default in model
      }
      this.testConfigDisplay.overall.push({
        name: 'Stream Rate Convention',
        value: this.streamRateConvention
      });

      this.scEnabled = false; //default in model is false

      if (parms['run-config-test'] === true) {
        this.scEnabled = true;
      }

      if (this.scEnabled === true) {
        this.testConfigDisplay.overall.push({
          name: 'Service Configuration Test',
          value: 'Enabled'
        });
        if (parms['step-percents']) {
          let displayVal = '';
          const steps = parms['step-percents'];
          for (const x in steps) {
            if (displayVal.length > 0) {
              displayVal += ' ';
            }
            displayVal += steps[x] + '%';
          }
          if (displayVal.length > 0) {
            displayVal += ' ';
          }
          displayVal += '100%';
          this.testConfigDisplay.overall.push({ name: 'Steps', value: displayVal });
        } else {
          this.testConfigDisplay.overall.push({ name: 'Steps', value: '100%' });
        }

        if (parms['step-duration']) {
          this.testConfigDisplay.overall.push({
            name: 'Step Duration',
            value: parms['step-duration'] + ' seconds'
          });
        } else if (this.qtVersion === 'v2') {
          this.testConfigDisplay.overall.push({ name: 'Step Duration', value: '10' + ' seconds' }); //default value in model
        } else {
          this.testConfigDisplay.overall.push({ name: 'Step Duration', value: 'unknown' }); // no default in model
        }
      } else {
        this.testConfigDisplay.overall.push({
          name: 'Service Configuration Test',
          value: 'Disabled'
        });
      }

      this.spEnabled = true; //default in model is true

      if (parms['run-perf-test'] === false) {
        this.spEnabled = false;
      }

      if (this.spEnabled === true) {
        this.testConfigDisplay.overall.push({ name: 'Service Performance Test', value: 'Enabled' });
        if (parms['perf-test-duration']) {
          const displayValue = this.helperService.convertSecondsToHMS(parms['perf-test-duration']);
          /*if (displayValue && typeof displayValue === 'string') {
                    displayValue = displayValue.replace(':', 'h ');
                    displayValue = displayValue.replace(':', 'm ');
                    displayValue += 's';
                }*/
          this.testConfigDisplay.overall.push({
            name: 'Performance Test Duration (HH:MM:SS)',
            value: displayValue
          });
        } else if (this.qtVersion === 'v2') {
          // v2 version default in model is 900 secs
          this.testConfigDisplay.overall.push({
            name: 'Performance Test Duration (HH:MM:SS)',
            value: '00:15:00'
          });
        } else {
          // default in model is 60 secs
          this.testConfigDisplay.overall.push({
            name: 'Performance Test Duration (HH:MM:SS)',
            value: '00:01:00'
          });
        }
      } else {
        this.testConfigDisplay.overall.push({
          name: 'Service Performance Test',
          value: 'Disabled'
        });
      }
    }
  }

  getStreamRateChartType(): string {
    return this.streamRateValue === 'l1-mbps' ? 'ULR' : 'IR';
  }

  // Create a flattened setup for each stream
  // Include default values from model in case the fields are not provided in the test configuration
  // Some values come from UI Data when it is available
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  createStreamsQTTestSetup() {
    let layerConfig;
    if (
      this.testConfig &&
      this.testConfig['y1564:y1564'] &&
      this.testConfig['y1564:y1564']['group'][0]['streams'] &&
      this.testConfig['y1564:y1564']['group'][0]['streams'].length
    ) {
      const numStreams = this.testConfig['y1564:y1564']['group'][0]['streams'].length;
      let addedDestination = false;
      let addedIPv6Configs = false;
      const testMode = this.testConfig['y1564:y1564']['y1564-parameters'].layer;

      for (let y = 0; y < numStreams; ++y) {
        const newStream = {};
        // start with default values from model in case attributes are not included in configuration
        newStream['run-policing-from-engine-a'] = 'No';
        newStream['run-policing-from-engine-b'] = 'No';
        newStream['frame-loss-ratio-threshold'] = 0;
        newStream['enable-frame-delay'] = 'No';
        newStream['frame-length'] = '';
        newStream['sct-frame-length'] = '';
        newStream['spt-frame-length'] = '';
        newStream['payload'] = this.payloadTypeArray['fill-byte'];
        newStream['tos'] = '00000000';
        newStream['ttl'] = 0;
        newStream['vlan'] = {
          tagging: '',
          cvlan: { id: '', priority: '' },
          svlan: { id: '', priority: '', tpid: '', deiEnabled: '' }
        };
        newStream['spt-emix-Frame'] = '';
        newStream['emix-Frame'] = '';
        if (this.qtVersion === 'v2') {
          newStream['tos'] = '0';
          newStream['ttl'] = 32;
          newStream['latency-FDV-maximum'] = 100;
        }

        for (const z in this.testConfig['y1564:y1564']['group'][0]['streams'][y]) {
          switch (z) {
            case 'name':
              // remove connection name since only one connection is supported
              // eslint-disable-next-line no-case-declarations
              const idx = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z].indexOf(':');
              if (
                idx > 0 &&
                this.testConfig['y1564:y1564']['group'][0]['streams'][y][z].length > idx + 1
              ) {
                newStream[z] = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z].substr(
                  idx + 1
                );
              } else {
                newStream[z] = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
              }
              break;

            case 'run-policing-from-engine-a':
            case 'run-policing-from-engine-b':
            case 'enable-frame-delay':
              if (this.testConfig['y1564:y1564']['group'][0]['streams'][y][z] === true) {
                newStream[z] = 'Yes';
              } else {
                newStream[z] = 'No';
              }
              break;

            case 'l2-config':
              // eslint-disable-next-line no-case-declarations
              let layerConfig = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
              if (testMode === 'L2') {
                if (layerConfig['destination-mac'] && addedDestination === false) {
                  this.testConfigDisplay.destination.push({
                    name: 'MAC Address',
                    value: layerConfig['destination-mac']
                  });
                  addedDestination = true; // only add once, it is the same for all streams
                }
              }
              if (layerConfig['sct-frame-size-list']) {
                const emixFrameSize = layerConfig['sct-frame-size-list'];
                if (emixFrameSize.indexOf('EMIX') === -1) {
                  newStream['spt-frame-length'] = layerConfig['spt-frame-size-list'];
                }
                newStream['sct-frame-length'] = layerConfig['sct-frame-size-list'];
              }
              if (layerConfig['spt-frame-size-list'].indexOf('EMIX') != -1) {
                const emixFrameList = layerConfig['spt-frame-size-list'].slice(
                  layerConfig['spt-frame-size-list'].indexOf('EMIX') + 5
                );

                newStream['spt-emix-Frame'] = emixFrameList;
              }
              if (layerConfig.tagging) {
                if (this.log) {
                  console.log('tagging is: ' + layerConfig.tagging);
                }
                newStream['vlan'].tagging = layerConfig.tagging;
              }
              if (layerConfig['payload']) {
                if (this.payloadTypeArray[layerConfig['payload']]) {
                  newStream['payload'] = this.payloadTypeArray[layerConfig['payload']];
                } else {
                  newStream['payload'] = layerConfig['payload'];
                }
              }
              if (layerConfig['vlan-priority'] >= 0) {
                newStream['vlan-priority'] = layerConfig['vlan-priority'];
              }
              if (layerConfig['inner-vlan-priority'] >= 0) {
                newStream['inner-vlan-priority'] = layerConfig['inner-vlan-priority'];
              }
              break;
            case 'vlan': // the single vlan case
            case 'cvlan': // one vlan of QINQ, also has the same fields as the 'vlan' object of single vlan case
              // eslint-disable-next-line no-case-declarations
              let vlanConfig = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
              if (this.log) {
                console.log('vlan or cvlan: ');
                console.log(vlanConfig);
              }
              newStream['vlan'].cvlan.id = vlanConfig.id;
              newStream['vlan'].cvlan.priority = vlanConfig.priority;
              break;
            case 'svlan': // svlan of QINQ
              // eslint-disable-next-line no-case-declarations
              vlanConfig = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
              if (this.log) {
                console.log('svlan: ');
                console.log(vlanConfig);
              }
              newStream['vlan'].svlan.id = vlanConfig.id;
              newStream['vlan'].svlan.priority = vlanConfig.priority;
              newStream['vlan'].svlan.tpid = vlanConfig.tpid;
              newStream['vlan'].svlan.deiEnabled = vlanConfig['dei-enabled'] ? 'true' : 'false';
              break;
            case 'l3-ipv6-config':
              if (testMode === 'L3') {
                layerConfig = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
                if (layerConfig['dest-ipv6-address'] && addedDestination === false) {
                  this.testConfigDisplay.destination.push({
                    name: 'IP Address',
                    value: layerConfig['dest-ipv6-address']
                  });
                  addedDestination = true; // only add once, it is the same for all streams
                }
                if (addedIPv6Configs === false) {
                  if (layerConfig['source-ipv6-address']) {
                    this.testConfigDisplay.ipv6Config.push({
                      name: 'Test Address',
                      value: layerConfig['source-ipv6-address']
                    });
                  }
                  if (layerConfig['src-subnet-prefix-length']) {
                    this.testConfigDisplay.ipv6Config.push({
                      name: 'Test Subnet Prefix',
                      value: layerConfig['src-subnet-prefix-length']
                    });
                  }
                  if (layerConfig['src-gateway-ipv6-address']) {
                    this.testConfigDisplay.ipv6Config.push({
                      name: 'Test Gateway',
                      value: layerConfig['src-gateway-ipv6-address']
                    });
                  }
                  addedIPv6Configs = true;
                }
              }
              if (layerConfig['traffic-class']) {
                newStream['traffic-class'] = layerConfig['traffic-class'];
              }
              if (layerConfig['hop-limit']) {
                newStream['hop-limit'] = layerConfig['hop-limit'];
              }
              break;
            case 'l3-ipv4-config':
              layerConfig = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
              if (layerConfig['destination-ip'] && addedDestination === false) {
                this.testConfigDisplay.destination.push({
                  name: 'IP Address',
                  value: layerConfig['destination-ip']
                });
                addedDestination = true; // only add once, it is the same for all streams
              }
              if (layerConfig['tos'] !== undefined && layerConfig['tos'] !== null) {
                newStream['toSDiffServSelection'] = 'ToS';
                newStream['toSDiffServValue'] = this.helperService.formatTOS(
                  layerConfig['tos'].toString()
                );
              }
              if (layerConfig['ttl']) {
                newStream['ttl'] = layerConfig['ttl'];
              }
              if (layerConfig['frame-length']) {
                newStream['frame-length'] = layerConfig['frame-length'];
              }
              if (layerConfig['payload']) {
                if (this.payloadTypeArray[layerConfig['payload']]) {
                  newStream['payload'] = this.payloadTypeArray[layerConfig['payload']];
                } else {
                  newStream['payload'] = layerConfig['payload'];
                }
              }
              break;
            default:
              newStream[z] = this.testConfig['y1564:y1564']['group'][0]['streams'][y][z];
              break;
          }
        }

        // get UI stream configuration if present because it's more accurate for display
        //
        if (newStream['stream-number']) {
          const uiStreamData = this.getUIStream(newStream['stream-number']);

          if (uiStreamData) {
            if (newStream['cir-from-engine-a'] && uiStreamData.strmSlaCir) {
              newStream['cir-from-engine-a'] = uiStreamData.strmSlaCir;
            }
            if (newStream['eir-from-engine-a'] && uiStreamData.strmSlaEir) {
              newStream['eir-from-engine-a'] = uiStreamData.strmSlaEir;
            }
            if (newStream['max-ir-from-engine-a'] && uiStreamData.strmSlaMaxIR) {
              newStream['max-ir-from-engine-a'] = uiStreamData.strmSlaMaxIR;
            }

            if (newStream['cir-from-engine-b'] && uiStreamData.strmSlaCir2) {
              newStream['cir-from-engine-b'] = uiStreamData.strmSlaCir2;
            }
            if (newStream['eir-from-engine-b'] && uiStreamData.strmSlaEir2) {
              newStream['eir-from-engine-b'] = uiStreamData.strmSlaEir2;
            }
            if (newStream['max-ir-from-engine-b'] && uiStreamData.strmSlaMaxIR2) {
              newStream['max-ir-from-engine-b'] = uiStreamData.strmSlaMaxIR2;
            }

            // While we have the UI data, retrieve the DSCP value if user entered it that way
            if (this.layerToTest == '3' || this.layerToTest == '2') {
              if (
                uiStreamData.strmIpv4ToSDiffServ &&
                uiStreamData.strmIpv4ToSDiffServ === 'diffserv'
              ) {
                newStream['toSDiffServSelection'] = 'DiffServ';
                newStream['toSDiffServValue'] = this.helperService.formatDiffValue(
                  uiStreamData.strmIpv4DiffServVal
                );
              }
            }
          }
        }
        if (newStream['cbs-size'] > 0) {
          let cbsAccessRate = newStream['cbs-remote-line-rate'];
          const cbsIndex = cbsAccessRate.indexOf('Mbps');
          if (cbsIndex != -1) {
            cbsAccessRate = cbsAccessRate.replace('Mbps', '') + ' Mbps';
          } else {
            cbsAccessRate = cbsAccessRate.replace('Gbps', '') + ' Gbps';
          }
          newStream['cbs-remote-line-rate'] = cbsAccessRate;
          const cbsKiloByte = newStream['cbs-kilo-size'].replace('cbs', '');
          newStream['cbs-kilo-size'] = cbsKiloByte;
        }
        if (this.log) {
          console.log('newStream is: ');
          console.log(newStream);
        }
        this.testConfigDisplay.streams.push(newStream);
      }
    }

    if (
      this.testConfig &&
      this.testConfig['viavi-solutions-y1564:y1564'] &&
      this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'] &&
      this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'].length
    ) {
      const numStreams =
        this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'].length;
      let addedDestination = false;
      let addedIPv6Configs = false;
      const testMode = this.testConfig['viavi-solutions-y1564:y1564']['y1564-parameters'].layer;

      for (let y = 0; y < numStreams; ++y) {
        const newStream = {};
        // start with default values from model in case attributes are not included in configuration
        newStream['run-policing-from-engine-a'] = 'No';
        newStream['run-policing-from-engine-b'] = 'No';
        newStream['frame-loss-ratio-threshold'] = 0;
        newStream['enable-frame-delay'] = 'No';
        newStream['frame-length'] = '';
        newStream['sct-frame-length'] = '';
        newStream['spt-frame-length'] = '';
        newStream['payload'] = this.payloadTypeArray['fill-byte'];
        newStream['tos'] = '00000000';
        newStream['ttl'] = 0;
        newStream['vlan'] = {
          tagging: '',
          cvlan: { id: '', priority: '' },
          svlan: { id: '', priority: '', tpid: '', deiEnabled: '' }
        };
        newStream['spt-emix-Frame'] = '';

        for (const z in this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y]) {
          switch (z) {
            case 'name':
              // remove connection name since only one connection is supported
              // eslint-disable-next-line no-case-declarations
              const idx =
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z].indexOf(
                  ':'
                );
              if (
                idx > 0 &&
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z].length >
                  idx + 1
              ) {
                newStream[z] = this.testConfig['viavi-solutions-y1564:y1564']['group'][0][
                  'streams'
                ][y][z].substr(idx + 1);
              } else {
                newStream[z] =
                  this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
              }
              break;

            case 'run-policing-from-engine-a':
            case 'run-policing-from-engine-b':
            case 'enable-frame-delay':
              if (
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z] === true
              ) {
                newStream[z] = 'Yes';
              } else {
                newStream[z] = 'No';
              }
              break;

            case 'l2-config':
              // eslint-disable-next-line no-case-declarations
              layerConfig =
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
              if (testMode === 'L2') {
                if (layerConfig['destination-mac'] && addedDestination === false) {
                  this.testConfigDisplay.destination.push({
                    name: 'MAC Address',
                    value: layerConfig['destination-mac']
                  });
                  addedDestination = true; // only add once, it is the same for all streams
                }
              }
              if (layerConfig['sct-frame-size-list']) {
                newStream['sct-frame-length'] = layerConfig['sct-frame-size-list'];
              }
              if (layerConfig['spt-frame-size-list']) {
                newStream['spt-frame-length'] = layerConfig['spt-frame-size-list'];
              }
              if (layerConfig.tagging) {
                if (this.log) {
                  console.log('tagging is: ' + layerConfig.tagging);
                }
                newStream['vlan'].tagging = layerConfig.tagging;
              }
              if (layerConfig['payload']) {
                if (this.payloadTypeArray[layerConfig['payload']]) {
                  newStream['payload'] = this.payloadTypeArray[layerConfig['payload']];
                } else {
                  newStream['payload'] = layerConfig['payload'];
                }
              }
              if (layerConfig['vlan-priority'] >= 0) {
                newStream['vlan-priority'] = layerConfig['vlan-priority'];
              }
              if (layerConfig['inner-vlan-priority'] >= 0) {
                newStream['inner-vlan-priority'] = layerConfig['inner-vlan-priority'];
              }
              break;
            case 'vlan': // the single vlan case
            case 'cvlan': // one vlan of QINQ, also has the same fields as the 'vlan' object of single vlan case
              // eslint-disable-next-line no-case-declarations
              let vlanConfig =
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
              if (this.log) {
                console.log('vlan or cvlan: ');
                console.log(vlanConfig);
              }
              newStream['vlan'].cvlan.id = vlanConfig.id;
              newStream['vlan'].cvlan.priority = vlanConfig.priority;
              break;
            case 'svlan': // svlan of QINQ
              vlanConfig =
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
              if (this.log) {
                console.log('svlan: ');
                console.log(vlanConfig);
              }
              newStream['vlan'].svlan.id = vlanConfig.id;
              newStream['vlan'].svlan.priority = vlanConfig.priority;
              newStream['vlan'].svlan.tpid = vlanConfig.tpid;
              newStream['vlan'].svlan.deiEnabled = vlanConfig['dei-enabled'] ? 'true' : 'false';
              break;
            case 'l3-ipv6-config':
              if (testMode === 'L3') {
                layerConfig =
                  this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
                if (layerConfig['dest-ipv6-address'] && addedDestination === false) {
                  this.testConfigDisplay.destination.push({
                    name: 'IP Address',
                    value: layerConfig['dest-ipv6-address']
                  });
                  addedDestination = true; // only add once, it is the same for all streams
                }
                if (addedIPv6Configs === false) {
                  if (layerConfig['source-ipv6-address']) {
                    this.testConfigDisplay.ipv6Config.push({
                      name: 'Test Address',
                      value: layerConfig['source-ipv6-address']
                    });
                  }
                  if (layerConfig['src-subnet-prefix-length']) {
                    this.testConfigDisplay.ipv6Config.push({
                      name: 'Test Subnet Prefix',
                      value: layerConfig['src-subnet-prefix-length']
                    });
                  }
                  if (layerConfig['src-gateway-ipv6-address']) {
                    this.testConfigDisplay.ipv6Config.push({
                      name: 'Test Gateway',
                      value: layerConfig['src-gateway-ipv6-address']
                    });
                  }
                  addedIPv6Configs = true;
                }
              }
              if (layerConfig['traffic-class']) {
                newStream['traffic-class'] = layerConfig['traffic-class'];
              }
              if (layerConfig['hop-limit']) {
                newStream['hop-limit'] = layerConfig['hop-limit'];
              }
              break;
            case 'l3-ipv4-config':
              // eslint-disable-next-line no-case-declarations
              layerConfig =
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
              if (layerConfig['destination-ip'] && addedDestination === false) {
                this.testConfigDisplay.destination.push({
                  name: 'IP Address',
                  value: layerConfig['destination-ip']
                });
                addedDestination = true; // only add once, it is the same for all streams
              }
              if (layerConfig['tos'] !== undefined && layerConfig['tos'] !== null) {
                newStream['toSDiffServSelection'] = 'ToS';
                newStream['toSDiffServValue'] = this.helperService.formatTOS(
                  layerConfig['tos'].toString()
                );
              }
              if (layerConfig['ttl']) {
                newStream['ttl'] = layerConfig['ttl'];
              }
              if (layerConfig['frame-length']) {
                newStream['frame-length'] = layerConfig['frame-length'];
              }
              if (layerConfig['payload']) {
                if (this.payloadTypeArray[layerConfig['payload']]) {
                  newStream['payload'] = this.payloadTypeArray[layerConfig['payload']];
                } else {
                  newStream['payload'] = layerConfig['payload'];
                }
              }
              break;
            default:
              newStream[z] =
                this.testConfig['viavi-solutions-y1564:y1564']['group'][0]['streams'][y][z];
              break;
          }
        }

        // get UI stream configuration if present because it's more accurate for display
        //
        if (newStream['stream-number']) {
          const uiStreamData = this.getUIStream(newStream['stream-number']);

          if (uiStreamData) {
            if (newStream['cir-from-engine-a'] && uiStreamData.strmSlaCir) {
              newStream['cir-from-engine-a'] = uiStreamData.strmSlaCir;
            }
            if (newStream['eir-from-engine-a'] && uiStreamData.strmSlaEir) {
              newStream['eir-from-engine-a'] = uiStreamData.strmSlaEir;
            }
            if (newStream['max-ir-from-engine-a'] && uiStreamData.strmSlaMaxIR) {
              newStream['max-ir-from-engine-a'] = uiStreamData.strmSlaMaxIR;
            }

            if (newStream['cir-from-engine-b'] && uiStreamData.strmSlaCir2) {
              newStream['cir-from-engine-b'] = uiStreamData.strmSlaCir2;
            }
            if (newStream['eir-from-engine-b'] && uiStreamData.strmSlaEir2) {
              newStream['eir-from-engine-b'] = uiStreamData.strmSlaEir2;
            }
            if (newStream['max-ir-from-engine-b'] && uiStreamData.strmSlaMaxIR2) {
              newStream['max-ir-from-engine-b'] = uiStreamData.strmSlaMaxIR2;
            }

            // While we have the UI data, retrieve the DSCP value if user entered it that way
            if (this.layerToTest == '3' || this.layerToTest == '2') {
              if (
                uiStreamData.strmIpv4ToSDiffServ &&
                uiStreamData.strmIpv4ToSDiffServ === 'diffserv'
              ) {
                newStream['toSDiffServSelection'] = 'DiffServ';
                newStream['toSDiffServValue'] = this.helperService.formatDiffValue(
                  uiStreamData.strmIpv4DiffServVal
                );
              }
            }
          }
        }
        if (newStream['cbs-size'] > 0) {
          let cbsAccessRate = newStream['cbs-remote-line-rate'];
          const cbsIndex = cbsAccessRate.indexOf('Mbps');
          if (cbsIndex != -1) {
            cbsAccessRate = cbsAccessRate.replace('Mbps', '') + ' Mbps';
          } else {
            cbsAccessRate = cbsAccessRate.replace('Gbps', '') + ' Gbps';
          }
          newStream['cbs-remote-line-rate'] = cbsAccessRate;
          const cbsKiloByte = newStream['cbs-kilo-size'].replace('cbs', '');
          newStream['cbs-kilo-size'] = cbsKiloByte;
        }
        if (this.log) {
          console.log('newStream is: ');
          console.log(newStream);
        }
        this.testConfigDisplay.streams.push(newStream);
      }
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  produceErrorQTObj(finalReport) {
    let errMsg = null;
    let flrErrorCount = 0;
    let fdErrorCount = 0;
    let fdvErrorCount = 0;
    let eirErrorCount = 0;
    let policingErrorCount = 0;
    let firstFailedStreamNum = null;
    let multipleStreamsFailed = false;
    let verdictReason = '';
    this.verdictReasonAvailable = false;
    if (finalReport != null) {
      for (let i = 0, len = finalReport.length; i < len; ++i) {
        let flrFailed = false;
        let fdFailed = false;
        let fdvFailed = false;
        const report = finalReport[i];
        if (report['verdict'] === 'fail') {
          if (firstFailedStreamNum === null) {
            firstFailedStreamNum = report['stream-number'];
            verdictReason = report['verdict-reason'];
            if (verdictReason) {
              this.verdictReasonAvailable = true;
            }
          } else {
            if (firstFailedStreamNum !== report['stream-number']) {
              multipleStreamsFailed = true;
            }
          }
          if (report['flr-verdict'] === 'fail') {
            flrFailed = true;
            flrErrorCount++;
          }
          if (report['fd-verdict'] === 'fail') {
            fdFailed = true;
            fdErrorCount++;
          }
          if (report['fdv-verdict'] === 'fail') {
            fdvFailed = true;
            fdvErrorCount++;
          }
          // if the stream failed the ramps, CIR or SP test is should be due to FLR or FD
          // if the stream failed EIR or Policing and it wasn't due to FLR or FD then report this specifically
          if (
            flrFailed === false &&
            fdFailed === false &&
            report['step-name'] &&
            typeof report['step-name'] === 'string'
          ) {
            if (report['step-name'].toLowerCase().indexOf('eir') >= 0) {
              eirErrorCount++;
            } else if (report['step-name'].toLowerCase().indexOf('policing') >= 0) {
              policingErrorCount++;
            }
          }
        }
      }
    }

    // Produce an error message

    if (
      flrErrorCount > 0 ||
      fdErrorCount > 0 ||
      fdvErrorCount > 0 ||
      eirErrorCount > 0 ||
      policingErrorCount > 0
    ) {
      let reason = '';
      if (multipleStreamsFailed === true) {
        errMsg = 'Multiple test failures occurred. Please review report for more details';
      } else if (firstFailedStreamNum !== null) {
        if (this.verdictReasonAvailable) {
          errMsg = '';
          reason = verdictReason || '';
        } else {
          errMsg = this.getStreamName(firstFailedStreamNum);
        }
      }
      if (errMsg !== null && !this.verdictReasonAvailable) {
        if (flrErrorCount > 0) {
          reason += ' frame loss threshold exceeded';
        }
        if (fdErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'FTD exceeded';
        }
        if (fdvErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'FDV exceeded';
        }
        if (eirErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'EIR step';
        }
        if (policingErrorCount > 0) {
          if (reason.length > 0) {
            reason += ', ';
          }
          reason += 'Policing step';
        }
        errMsg += ' failed due to ' + reason;
      }
      if (verdictReason !== '') {
        errMsg += reason;
      }
    }
    return errMsg;
  }

  // Function to capitalize the first letter of a string
  capitalizeFirstLetter(str: string): string {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  // Function to format the unit convention string
  formatUnitConvention(unitConvention: string): string {
    // Split the string on '-'
    const parts = unitConvention.split('-');
    // Capitalize the first part and ensure the second part is 'Mbps'
    const capitalizedPart = this.capitalizeFirstLetter(parts[0]);
    const capitalizedSecondPart = this.capitalizeFirstLetter(parts[1]);
    const formattedUnit = `${capitalizedPart}-${capitalizedSecondPart}`;
    return formattedUnit;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  formatFLR(value): any {
    const floatVal = parseFloat(value);
    if (this.isJmep) {
      return floatVal;
    }
    if (floatVal < 0.0 || floatVal > 1.0) {
      //suppress negative values
      return '--';
    }
    return this.convertFLRToPercent(floatVal);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  convertFLRToPercent(value: any): any {
    // convert ratio to percentage
    let floatVal = value * 100;

    if (floatVal > 1.0) {
      floatVal = Math.round(floatVal * 10) / 10; // round to 1 decimal place
    } else {
      floatVal = Math.round(floatVal * 1000000) / 1000000; // round to 6 decimal places
      if (parseFloat(value) > 0.0) {
        floatVal = Math.max(floatVal, 0.000001);
      }
    }
    return floatVal;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.expertView) {
      this.expertView = changes.expertView.currentValue;
    }
    if (changes && (changes.runId || changes.reportStartTime)) {
      this.requestInfo = {};
      this.upstreamSummary = {};
      this.downstreamSummary = {};
      this.testSummary = {};
      this.clientInfo = {};
      this.windowResults = [];
      this.windowSummary = [];
      this.configuration = {};
      this.upstreamWindowResult = null;
      this.downstreamWindowResult = null;
      this.uiStreams = [];
      this.sptStreamsMetricData = [];
      this.performanceData = [];
      this.trendChartsData = false;
      this.testConfigDisplay = {
        overall: [],
        streams: [],
        destination: [],
        tpaVersion: null,
        tpbVersion: null
      };
      this.init();
    }
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
    if (this.log) {
      console.log('DESTROY');
    }

    this.chartArray.forEach(chart => {
      chart.destroy();
    });
    this.chartArray = [];

    this.chartIdArray.forEach(id => {
      const chartElem = document.getElementById(id);
      if (chartElem) {
        while (chartElem.firstChild) {
          chartElem.removeChild(chartElem.firstChild);
        }
      }
    });
    this.chartIdArray = [];

    this.trendingInProgress = false;
  }
  getLoopUpValue(): boolean {
    const loopUpValue =
      this.y1564TestConfig['viavi-solutions-y1564:y1564']['y1564-parameters'][
        'suppress-loop-commands'
      ] === false
        ? true
        : false;
    return loopUpValue;
  }
}
